import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
};

export type AdminUpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  listingsCountries?: InputMaybe<Array<InputMaybe<ListingsCountry>>>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AverageResponse = {
  value?: Maybe<Scalars['Float']>;
};

export type BooleanFilter = {
  field?: Maybe<Scalars['String']>;
  operator?: Maybe<BooleanOperators>;
};

export type BooleanFilterInput = {
  field?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<BooleanOperatorsInput>;
};

export type BooleanOperators = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type BooleanOperatorsInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

export type BucketElement = {
  count: Scalars['Int'];
  key: Scalars['String'];
};

export type BucketElementConnection = {
  nodes?: Maybe<Array<Maybe<BucketElement>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BucketElementKey = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type Coordinates = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CoordinatesInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum CountField {
  Certified = 'certified',
  DealerCity = 'dealerCity',
  DealerName = 'dealerName',
  DealerState = 'dealerState',
  DealerType = 'dealerType',
  Doors = 'doors',
  DrivetrainFromVin = 'drivetrainFromVin',
  EngineFromVin = 'engineFromVin',
  FuelTypeFromVin = 'fuelTypeFromVin',
  HasLeather = 'hasLeather',
  HasNavigation = 'hasNavigation',
  ListingDropoffDate = 'listingDropoffDate',
  ListingFirstDate = 'listingFirstDate',
  ListingType = 'listingType',
  Make = 'make',
  Mileage = 'mileage',
  Model = 'model',
  ModelYear = 'modelYear',
  Price = 'price',
  Series = 'series',
  StockType = 'stockType',
  Style = 'style',
  TransmissionFromVin = 'transmissionFromVin'
}

export type CreateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  listingsCountries?: InputMaybe<Array<InputMaybe<ListingsCountry>>>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateTagInput = {
  name: Scalars['String'];
};

export type CreateUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
};

export type DateFilter = {
  field?: Maybe<FilterDateField>;
  operator?: Maybe<DateOperators>;
};

export type DateFilterInput = {
  field?: InputMaybe<FilterDateField>;
  operator?: InputMaybe<DateOperatorsInput>;
};

export type DateInterval = {
  unit: DateIntervalUnit;
  value: Scalars['Int'];
};

export type DateIntervalInput = {
  unit: DateIntervalUnit;
  value: Scalars['Int'];
};

export enum DateIntervalUnit {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  /** Only single calendar units are supported (that is, 1 month) */
  Month = 'Month',
  /** Only single calendar units are supported (that is, 1 quarter) */
  Quarter = 'Quarter',
  Second = 'Second',
  /** Only single calendar units are supported (that is, 1 week) */
  Week = 'Week',
  /** Only single calendar units are supported (that is, 1 year) */
  Year = 'Year'
}

export type DateOperators = {
  between?: Maybe<DateRange>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
};

export type DateOperatorsInput = {
  between?: InputMaybe<DateRangeInput>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
};

export type DateRange = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type DateRangeInput = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export enum DistanceUnit {
  Kilometers = 'Kilometers',
  Miles = 'Miles'
}

export enum FieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  Make = 'Make',
  Model = 'Model',
  Number = 'Number',
  String = 'String'
}

export type FieldValueGeoMetricResponse = {
  geo?: Maybe<Array<Maybe<FieldValueGeoResponse>>>;
  geoResults?: Maybe<Array<Maybe<KpiGeoResult>>>;
  kpi?: Maybe<Scalars['String']>;
};

export type FieldValueGeoResponse = {
  count?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  valueCount?: Maybe<Scalars['Int']>;
};

export type FieldValueMultiMetricResponse = {
  kpi?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['ID']>;
  stats?: Maybe<FieldValueStatsResponse>;
};

export type FieldValueStatResponse = {
  count?: Maybe<Scalars['Int']>;
  valueCount?: Maybe<Scalars['Int']>;
};

export type FieldValueStatsResponse = {
  active?: Maybe<FieldValueStatResponse>;
  all?: Maybe<FieldValueStatResponse>;
  sold?: Maybe<FieldValueStatResponse>;
};

export enum FilterBooleanField {
  Certified = 'certified',
  HasLeather = 'hasLeather',
  HasNavigation = 'hasNavigation',
  PriceAnalysis = 'priceAnalysis'
}

export type FilterConfiguration = {
  modelFilterConfiguration?: Maybe<ModelFilterConfiguration>;
  numberFilterConfiguration?: Maybe<NumberFilterConfiguration>;
  stringFilterConfiguration?: Maybe<StringFilterConfiguration>;
};

export enum FilterDateField {
  ListingDropoffDate = 'listingDropoffDate',
  ListingFirstDate = 'listingFirstDate',
  ListingLastDate = 'listingLastDate'
}

/** All these fields are guaranteed to have a 1:1 match in any of the FilterXField enums. */
export enum FilterField {
  Certified = 'certified',
  DealerCity = 'dealerCity',
  DealerId = 'dealerId',
  DealerListingMsrp = 'dealerListingMSRP',
  DealerName = 'dealerName',
  DealerPhone = 'dealerPhone',
  DealerState = 'dealerState',
  DealerStreet = 'dealerStreet',
  DealerType = 'dealerType',
  DealerUrl = 'dealerUrl',
  DealerZipcode = 'dealerZipcode',
  Doors = 'doors',
  DrivetrainFromVin = 'drivetrainFromVin',
  EngineFromVin = 'engineFromVin',
  ExteriorColor = 'exteriorColor',
  ExteriorColorCategory = 'exteriorColorCategory',
  FuelTypeFromVin = 'fuelTypeFromVin',
  HasLeather = 'hasLeather',
  HasNavigation = 'hasNavigation',
  Id = 'id',
  InteriorColor = 'interiorColor',
  InteriorColorCategory = 'interiorColorCategory',
  ListingDropoffDate = 'listingDropoffDate',
  ListingFirstDate = 'listingFirstDate',
  ListingHeading = 'listingHeading',
  ListingLastDate = 'listingLastDate',
  ListingType = 'listingType',
  ListingUrl = 'listingUrl',
  LocationScore = 'locationScore',
  Make = 'make',
  Mileage = 'mileage',
  Model = 'model',
  ModelYear = 'modelYear',
  Msrp = 'msrp',
  NumberPriceChanges = 'numberPriceChanges',
  OptionalFeatures = 'optionalFeatures',
  Price = 'price',
  PriceAnalysis = 'priceAnalysis',
  SegmentIds = 'segmentIds',
  Series = 'series',
  StandardFeatures = 'standardFeatures',
  StockType = 'stockType',
  Style = 'style',
  TransmissionFromVin = 'transmissionFromVin',
  Uvc = 'uvc',
  Vin = 'vin'
}

export enum FilterNumberField {
  DealerListingMsrp = 'dealerListingMSRP',
  Doors = 'doors',
  LocationScore = 'locationScore',
  Mileage = 'mileage',
  ModelYear = 'modelYear',
  Msrp = 'msrp',
  NumberPriceChanges = 'numberPriceChanges',
  Price = 'price',
  SegmentIds = 'segmentIds'
}

export enum FilterStringField {
  DealerCity = 'dealerCity',
  DealerId = 'dealerId',
  DealerName = 'dealerName',
  DealerPhone = 'dealerPhone',
  DealerState = 'dealerState',
  DealerStreet = 'dealerStreet',
  DealerType = 'dealerType',
  DealerUrl = 'dealerUrl',
  DealerZipcode = 'dealerZipcode',
  DrivetrainFromVin = 'drivetrainFromVin',
  EngineFromVin = 'engineFromVin',
  ExteriorColor = 'exteriorColor',
  ExteriorColorCategory = 'exteriorColorCategory',
  FuelTypeFromVin = 'fuelTypeFromVin',
  Id = 'id',
  InteriorColor = 'interiorColor',
  InteriorColorCategory = 'interiorColorCategory',
  ListingHeading = 'listingHeading',
  ListingType = 'listingType',
  ListingUrl = 'listingUrl',
  Make = 'make',
  Model = 'model',
  OptionalFeatures = 'optionalFeatures',
  Series = 'series',
  StandardFeatures = 'standardFeatures',
  StockType = 'stockType',
  Style = 'style',
  TransmissionFromVin = 'transmissionFromVin',
  Uvc = 'uvc',
  Vin = 'vin'
}

export type GeoDistanceOperator = {
  distance: Scalars['Int'];
  location: Coordinates;
  unit: DistanceUnit;
};

export type GeoDistanceOperatorInput = {
  distance: Scalars['Int'];
  location: CoordinatesInput;
  unit: DistanceUnit;
};

export type GeoFilter = {
  excludedZipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  operator: GeoOperators;
  place?: Maybe<GeoFilterPlace>;
};

export type GeoFilterInput = {
  excludedZipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator: GeoOperatorsInput;
  place?: InputMaybe<GeoFilterPlaceInput>;
};

export type GeoFilterPlace = {
  address: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};

export type GeoFilterPlaceInput = {
  address: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
};

export type GeoOperators = {
  distance?: Maybe<GeoDistanceOperator>;
  polygon?: Maybe<Array<Coordinates>>;
  region?: Maybe<Scalars['String']>;
};

export type GeoOperatorsInput = {
  distance?: InputMaybe<GeoDistanceOperatorInput>;
  /**
   * This array needs to have a size between 4 and 100 pairs of point locations. The last point must match the
   * first one in order to indicate the user closed the polygon.
   */
  polygon?: InputMaybe<Array<CoordinatesInput>>;
  region?: InputMaybe<Scalars['String']>;
};

export type GeoPoint = {
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

export type HistogramFilter = {
  booleanFilter?: Maybe<BooleanFilter>;
  dateFilter?: Maybe<DateFilter>;
  numberFilter?: Maybe<NumberFilter>;
  stringFilter?: Maybe<StringFilter>;
};

export type HistogramFilterInput = {
  booleanFilter?: InputMaybe<BooleanFilterInput>;
  dateFilter?: InputMaybe<DateFilterInput>;
  numberFilter?: InputMaybe<NumberFilterInput>;
  stringFilter?: InputMaybe<StringFilterInput>;
};

export type HistogramResponse = {
  average?: Maybe<Scalars['Float']>;
  histogram?: Maybe<Array<Maybe<NumberHistogramBucketElement>>>;
};

export type Invite = {
  acceptedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  createdByUserId: Scalars['ID'];
  declinedAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  inviter?: Maybe<User>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID'];
  owner: Scalars['Boolean'];
  status: Scalars['String'];
  updatedAt: Scalars['Date'];
  user?: Maybe<User>;
};

export type InviteInput = {
  email: Scalars['String'];
  organizationId: Scalars['ID'];
  /** Whether the invited user should become an owner of the organization. Default is false. */
  owner?: InputMaybe<Scalars['Boolean']>;
};

export type KpiFieldValueMetricResponse = {
  kpi?: Maybe<Scalars['String']>;
  stats?: Maybe<KpiFieldValueStatResponse>;
};

export type KpiFieldValueStatResponse = {
  active?: Maybe<FieldValueStatResponse>;
  all?: Maybe<FieldValueStatResponse>;
  sold?: Maybe<FieldValueStatResponse>;
};

export type KpiGeoMetricsResponse = {
  geo?: Maybe<Array<Maybe<KpiGeoResponse>>>;
  geoResults?: Maybe<Array<Maybe<KpiGeoResult>>>;
  kpi?: Maybe<Scalars['String']>;
};

export type KpiGeoResponse = {
  avg?: Maybe<AverageResponse>;
  count?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
};

export type KpiGeoResult = {
  count: Scalars['Int'];
  postalCodes: Array<Maybe<Scalars['String']>>;
};

export type KpiIndividualGeoMetricsResponse = {
  geo?: Maybe<Array<Maybe<KpiIndividualGeoResponse>>>;
  geoResults?: Maybe<Array<Maybe<KpiGeoResult>>>;
  kpi?: Maybe<Scalars['String']>;
};

export type KpiIndividualGeoResponse = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type KpiItem = {
  filterField?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum KpiLevel {
  Listing = 'LISTING',
  Vin = 'VIN'
}

export type KpiMetricsResponse = {
  kpi?: Maybe<Scalars['String']>;
  stats?: Maybe<KpiStatsResponse>;
};

export type KpiMetricsSingleValueMultiMetricResponse = {
  kpi?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['Float']>;
};

export type KpiMetricsSingleValueResponse = {
  kpi?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type KpiMultiMetricsResponse = {
  kpi?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['ID']>;
  stats?: Maybe<KpiStatsResponse>;
};

export type KpiStatFieldResponse = {
  avg?: Maybe<AverageResponse>;
  count?: Maybe<Scalars['Int']>;
  percentageChange?: Maybe<Scalars['Float']>;
};

export type KpiStatsResponse = {
  active?: Maybe<KpiStatFieldResponse>;
  all?: Maybe<KpiStatFieldResponse>;
  sold?: Maybe<KpiStatFieldResponse>;
};

export type Listing = {
  certified?: Maybe<Scalars['Boolean']>;
  dealerCity?: Maybe<Scalars['String']>;
  dealerId?: Maybe<Scalars['String']>;
  dealerListingMSRP?: Maybe<Scalars['Int']>;
  dealerLocation?: Maybe<GeoPoint>;
  dealerName?: Maybe<Scalars['String']>;
  dealerPhone?: Maybe<Scalars['String']>;
  dealerState?: Maybe<Scalars['String']>;
  dealerStreet?: Maybe<Scalars['String']>;
  dealerType?: Maybe<Scalars['String']>;
  dealerUrl?: Maybe<Scalars['String']>;
  dealerZipcode?: Maybe<Scalars['String']>;
  doors?: Maybe<Scalars['Int']>;
  drivetrainFromVin?: Maybe<Scalars['String']>;
  engineFromVin?: Maybe<Scalars['String']>;
  exteriorColor?: Maybe<Scalars['String']>;
  exteriorColorCategory?: Maybe<Scalars['String']>;
  fuelTypeFromVin?: Maybe<Scalars['String']>;
  hasLeather?: Maybe<Scalars['Boolean']>;
  hasNavigation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  intentMsgMileage?: Maybe<Scalars['String']>;
  intentMsgPrice?: Maybe<Scalars['String']>;
  interiorColor?: Maybe<Scalars['String']>;
  interiorColorCategory?: Maybe<Scalars['String']>;
  listedDays?: Maybe<Scalars['Int']>;
  listingDropoffDate?: Maybe<Scalars['Date']>;
  listingFirstDate?: Maybe<Scalars['Date']>;
  listingHeading?: Maybe<Scalars['String']>;
  listingLastDate?: Maybe<Scalars['Date']>;
  listingType?: Maybe<Scalars['String']>;
  listingUrl?: Maybe<Scalars['String']>;
  locationScore?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['Int']>;
  msrp?: Maybe<Scalars['Int']>;
  numberPriceChanges?: Maybe<Scalars['Int']>;
  optionalFeatures?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceAnalysis?: Maybe<Scalars['Boolean']>;
  priceHistory?: Maybe<Array<Maybe<PriceTag>>>;
  segmentIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  sellerNotes?: Maybe<Scalars['String']>;
  series?: Maybe<Scalars['String']>;
  standardFeatures?: Maybe<Scalars['String']>;
  stockType?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  transmissionFromVin?: Maybe<Scalars['String']>;
  uvc?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  wheelBaseFromVin?: Maybe<Scalars['Float']>;
};

export type ListingConnection = {
  nodes?: Maybe<Array<Maybe<Listing>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ListingField = {
  configuration?: Maybe<FilterConfiguration>;
  filterField: FilterField;
  title: Scalars['String'];
  type: FieldType;
};

export type ListingFilter = {
  booleanFilter?: Maybe<BooleanFilter>;
  dateFilter?: Maybe<DateFilter>;
  geoFilter?: Maybe<GeoFilter>;
  makeModelFilter?: Maybe<MakeModelFilter>;
  numberFilter?: Maybe<NumberFilter>;
  stringFilter?: Maybe<StringFilter>;
};

export type ListingFilterInput = {
  booleanFilter?: InputMaybe<BooleanFilterInput>;
  dateFilter?: InputMaybe<DateFilterInput>;
  geoFilter?: InputMaybe<GeoFilterInput>;
  makeModelFilter?: InputMaybe<MakeModelFilterInput>;
  numberFilter?: InputMaybe<NumberFilterInput>;
  stringFilter?: InputMaybe<StringFilterInput>;
};

export enum ListingsCountry {
  Ca = 'CA',
  Us = 'US'
}

export type Location = {
  address?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export enum LogicalOperator {
  And = 'And',
  Or = 'Or'
}

export type MakeModelCombination = {
  make: Scalars['String'];
  model: Array<Scalars['String']>;
};

export type MakeModelCombinationInput = {
  make: Scalars['String'];
  model: Array<Scalars['String']>;
};

export type MakeModelFilter = {
  combinations: Array<MakeModelCombination>;
};

export type MakeModelFilterInput = {
  combinations: Array<MakeModelCombinationInput>;
};

export type ModelFilterConfiguration = {
  make?: Maybe<Scalars['String']>;
};

export type Mutation = {
  _?: Maybe<Scalars['Boolean']>;
  /** Accepts an invite with the passed id */
  acceptInvite?: Maybe<Invite>;
  /** Updates that only admins can do */
  adminUpdateOrganization?: Maybe<Organization>;
  /** Creates an invite with the passed params and the authenticated user as the inviter */
  createInvite?: Maybe<Invite>;
  /** Creates an organization with the current user as the owner */
  createOrganization?: Maybe<Organization>;
  /** Creates a segment from the global database wih the information sent */
  createSegmentFromGlobalDb?: Maybe<Segment>;
  /** Creates a segment from an uploaded document */
  createSegmentFromVins?: Maybe<Segment>;
  /** Creates a Tag with a specific name */
  createTag?: Maybe<Tag>;
  /** Creates an user with with the information sent from global */
  createUser?: Maybe<User>;
  /** Declines an invite with the id */
  declineInvite?: Maybe<Invite>;
  /** Deletes an invite with the id */
  deleteInvite?: Maybe<Invite>;
  /** Deletes a Segment */
  deleteSegment?: Maybe<Segment>;
  /** Deletes a Tag */
  deleteTag?: Maybe<Tag>;
  /** Removes the member with *userId* from the organization with *id* */
  removeMember?: Maybe<Scalars['Boolean']>;
  /** Resends an invite with the passed id */
  resendInvite?: Maybe<Invite>;
  /** Creates an Organization with data from global */
  systemCreateOrganization?: Maybe<Organization>;
  /** Creates an User with User Admin permissions */
  systemCreateUser?: Maybe<User>;
  /** Updates an Organization with Org Admin permissions */
  systemUpdateOrganization?: Maybe<Organization>;
  /** Updates a system Segment */
  systemUpdateSegment?: Maybe<Segment>;
  /** Updates an User with User Admin permissions */
  systemUpdateUser?: Maybe<User>;
  /** Adds a Tag to a Segment */
  tagSegment?: Maybe<Segment>;
  /** Removes the Tag from a Segment */
  untagSegment?: Maybe<Segment>;
  updateMe?: Maybe<User>;
  /** Updates the organization with *id* using the passed params */
  updateOrganization?: Maybe<Organization>;
  /** Updates a Segment */
  updateSegment?: Maybe<Segment>;
  /** Updates a Tag */
  updateTag?: Maybe<Tag>;
};


export type MutationAcceptInviteArgs = {
  id: Scalars['ID'];
};


export type MutationAdminUpdateOrganizationArgs = {
  input: AdminUpdateOrganizationInput;
};


export type MutationCreateInviteArgs = {
  inviteParams?: InputMaybe<InviteInput>;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationCreateSegmentFromGlobalDbArgs = {
  segment?: InputMaybe<SegmentFromGlobalDbInput>;
};


export type MutationCreateSegmentFromVinsArgs = {
  segment?: InputMaybe<SegmentFromVinsInput>;
};


export type MutationCreateTagArgs = {
  input?: InputMaybe<CreateTagInput>;
};


export type MutationCreateUserArgs = {
  user?: InputMaybe<CreateUserInput>;
};


export type MutationDeclineInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSegmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveMemberArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationResendInviteArgs = {
  id: Scalars['ID'];
};


export type MutationSystemCreateOrganizationArgs = {
  organization?: InputMaybe<SystemOrganizationInput>;
  userId: Scalars['ID'];
};


export type MutationSystemCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationSystemUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateSystemOrganizationInput>;
};


export type MutationSystemUpdateSegmentArgs = {
  input: SystemSegmentUpdateInput;
};


export type MutationSystemUpdateUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationTagSegmentArgs = {
  id: Scalars['ID'];
  tagId: Scalars['ID'];
};


export type MutationUntagSegmentArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateMeArgs = {
  user?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationUpdateSegmentArgs = {
  input: SegmentUpdateInput;
};


export type MutationUpdateTagArgs = {
  input?: InputMaybe<UpdateTagInput>;
};

export type NumberFilter = {
  field?: Maybe<FilterNumberField>;
  operator?: Maybe<NumberOperators>;
};

export type NumberFilterConfiguration = {
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['String']>;
};

export type NumberFilterInput = {
  field?: InputMaybe<FilterNumberField>;
  operator?: InputMaybe<NumberOperatorsInput>;
};

export type NumberHistogramBucketElement = {
  count: Scalars['Int'];
  key: BucketElementKey;
};

export type NumberOperators = {
  between?: Maybe<NumberRange>;
  eq?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
};

export type NumberOperatorsInput = {
  between?: InputMaybe<NumberRangeInput>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type NumberRange = {
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

export type NumberRangeInput = {
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
};

export type Organization = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  listingsCountries?: Maybe<Array<Maybe<ListingsCountry>>>;
  name?: Maybe<Scalars['String']>;
  owned?: Maybe<Scalars['Boolean']>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  phone?: Maybe<Scalars['String']>;
  seatsTaken?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  totalSeats?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  zip?: Maybe<Scalars['String']>;
};

export type OrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  listingsCountries?: InputMaybe<Array<InputMaybe<ListingsCountry>>>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  totalSeats?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items?. */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PriceTag = {
  price?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Query = {
  _?: Maybe<Scalars['Boolean']>;
  /** Gets counts of listings for the provided date field. Counts are returned in buckets defined by the provided date interval. */
  dateHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Returns the counts for a specific property field */
  fieldCounts: BucketElementConnection;
  /** Returns the kpi "Listing Volume" for a specific date range and filters */
  fieldValueGeoMetric?: Maybe<FieldValueGeoMetricResponse>;
  /**
   * Gets counts of listings for the days on market kpi. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   */
  fieldValueHistogram?: Maybe<HistogramResponse>;
  /** Calculates the KPI for the field and value requested, with the filters and date range given. */
  fieldValueKpiMetric?: Maybe<KpiFieldValueMetricResponse>;
  /** Calculates the requested KPI for the list of segments provided. */
  fieldValueMultiMetric?: Maybe<Array<Maybe<FieldValueMultiMetricResponse>>>;
  /** Get invite information. */
  invite?: Maybe<Invite>;
  /** Returns the kpi "Days on Market" for a specific date range and filters */
  kpiDaysOnMarket?: Maybe<KpiMetricsResponse>;
  /** Returns the kpi metrics for a specific zoom leven with date range and filters */
  kpiGeoMetrics?: Maybe<KpiGeoMetricsResponse>;
  /**
   * Gets counts of listings for the provided number field. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   */
  kpiHistogram?: Maybe<HistogramResponse>;
  /** Returns all available kpis, with information such as kpi title and type */
  kpiList?: Maybe<Array<Maybe<KpiItem>>>;
  /** Returns the kpi metrics for a specific date range and filters */
  kpiMetrics?: Maybe<KpiMetricsResponse>;
  /** Calculates the requested KPI for the list of segments provided. */
  kpiMultiMetric?: Maybe<Array<Maybe<KpiMultiMetricsResponse>>>;
  /** Returns the kpi "Days on market" for a specific date range and filters */
  listingDaysOnMarketGeoMetric?: Maybe<KpiGeoMetricsResponse>;
  /**
   * Gets counts of listings for the days on market kpi. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   */
  listingDaysOnMarketHistogram?: Maybe<HistogramResponse>;
  /** Calculates the days on market KPI for the requested segments. */
  listingDaysOnMarketMultiMetric?: Maybe<Array<Maybe<KpiMultiMetricsResponse>>>;
  /**
   * Gets average listing field values over time for trend visualization
   * Uses the same pattern as listingVolumeHistogram but aggregates by the provided field
   */
  listingFieldHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Get the listing KPI list information */
  listingFields?: Maybe<Array<Maybe<ListingField>>>;
  /** Returns the kpi "Market Supply Days" for a specific zoom leven with date range and filters */
  listingMarketDaysSupplyGeoMetric?: Maybe<KpiIndividualGeoMetricsResponse>;
  /** Returns the kpi "Market Supply Days" for a specific date range and filters */
  listingMarketDaysSupplyMetric?: Maybe<KpiMetricsSingleValueResponse>;
  /** Listing the kpi "Market Supply Days" for the given segments and date range. */
  listingMarketDaysSupplyMultiMetric?: Maybe<Array<Maybe<KpiMetricsSingleValueMultiMetricResponse>>>;
  /** Returns the counts of the listingTypes */
  listingTypeCounts?: Maybe<Array<Maybe<BucketElement>>>;
  /** Returns the kpi "Listing Volume" for a specific date range and filters */
  listingVolumeGeoMetric?: Maybe<KpiGeoMetricsResponse>;
  /** Gets counts of listings volume for the provided date range and date interval */
  listingVolumeHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Returns the kpi "Listing Volume" for a specific date range and filters */
  listingVolumeMetric?: Maybe<KpiMetricsResponse>;
  /** Listing volume kpi for the given segments and date range. */
  listingVolumeMultiMetric?: Maybe<Array<Maybe<KpiMultiMetricsResponse>>>;
  /** Get all the listings in the system */
  listingsSnapshot: ListingConnection;
  /** Returns the counts for a specific vehicle make filter */
  makeModelCounts?: Maybe<Array<Maybe<BucketElement>>>;
  /** Current authenticated user information and settings */
  me?: Maybe<User>;
  /** Get organization information. */
  organization?: Maybe<Organization>;
  /** Gets a segment based on a segment id */
  segment?: Maybe<Segment>;
  /** List all the segments in the system. */
  segments?: Maybe<SegmentConnection>;
  /** Get invite information. Only works with API tokens with the system:read scope. */
  systemInvite?: Maybe<Invite>;
  /** Gets a list of listings based on a field name and a list of entries. */
  systemListingsByFieldName?: Maybe<Array<Maybe<Listing>>>;
  /** Get organization information. Only works with API tokens with the system:read scope. */
  systemOrganization?: Maybe<Organization>;
  /** Gets a segment based on a segment id and a system query. */
  systemSegment?: Maybe<Segment>;
  /** Get user information. Only works with API tokens with the system:read scope. */
  systemUser?: Maybe<User>;
  /** Get UserOrganization information. Only works with API tokens with the system:read scope. */
  systemUserOrganization?: Maybe<UserOrganization>;
  /** List all the users in the system. Only works with API tokens with the system:read scope. */
  systemUsers?: Maybe<UserConnection>;
  /** Gets a tag based on a Tag id */
  tag?: Maybe<Tag>;
  /** List all the tags for a specific org. */
  tags?: Maybe<TagConnection>;
  /** Get all the vehicles in the system */
  vehiclesSnapshot: VehicleConnection;
};


export type QueryDateHistogramArgs = {
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  field: FilterDateField;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  interval: DateIntervalInput;
  kpiLevel?: InputMaybe<KpiLevel>;
  max?: InputMaybe<Scalars['Date']>;
  min?: InputMaybe<Scalars['Date']>;
};


export type QueryFieldCountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  propertyName?: InputMaybe<CountField>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryFieldValueGeoMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  field: ValueField;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  value: Scalars['String'];
  zoomLevel: ZoomLevelInput;
};


export type QueryFieldValueHistogramArgs = {
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  field: ValueField;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  value: Scalars['String'];
};


export type QueryFieldValueKpiMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  field: ValueField;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  value: Scalars['String'];
};


export type QueryFieldValueMultiMetricArgs = {
  dateRange: DateRangeInput;
  field: ValueField;
  kpiLevel?: InputMaybe<KpiLevel>;
  segmentIds: Array<Scalars['ID']>;
  value: Scalars['String'];
};


export type QueryInviteArgs = {
  id: Scalars['ID'];
};


export type QueryKpiDaysOnMarketArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
};


export type QueryKpiGeoMetricsArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpi: FilterNumberField;
  kpiLevel?: InputMaybe<KpiLevel>;
  zoomLevel: ZoomLevelInput;
};


export type QueryKpiHistogramArgs = {
  bucketCount?: InputMaybe<Scalars['Int']>;
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  field: FilterNumberField;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  interval?: InputMaybe<Scalars['Int']>;
  kpiLevel?: InputMaybe<KpiLevel>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']>;
};


export type QueryKpiMetricsArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpi: FilterNumberField;
  kpiLevel?: InputMaybe<KpiLevel>;
  percentageChange?: InputMaybe<Scalars['Boolean']>;
};


export type QueryKpiMultiMetricArgs = {
  dateRange: DateRangeInput;
  kpi: FilterNumberField;
  kpiLevel?: InputMaybe<KpiLevel>;
  segmentIds: Array<Scalars['ID']>;
};


export type QueryListingDaysOnMarketGeoMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  zoomLevel: ZoomLevelInput;
};


export type QueryListingDaysOnMarketHistogramArgs = {
  bucketCount?: InputMaybe<Scalars['Int']>;
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  interval?: InputMaybe<Scalars['Int']>;
  kpiLevel?: InputMaybe<KpiLevel>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']>;
};


export type QueryListingDaysOnMarketMultiMetricArgs = {
  dateRange: DateRangeInput;
  kpiLevel?: InputMaybe<KpiLevel>;
  segmentIds: Array<Scalars['ID']>;
};


export type QueryListingFieldHistogramArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  field: FilterNumberField;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  interval: DateIntervalInput;
  kpiLevel?: InputMaybe<KpiLevel>;
};


export type QueryListingFieldsArgs = {
  makeFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryListingMarketDaysSupplyGeoMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  zoomLevel: ZoomLevelInput;
};


export type QueryListingMarketDaysSupplyMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
};


export type QueryListingMarketDaysSupplyMultiMetricArgs = {
  dateRange: DateRangeInput;
  kpiLevel?: InputMaybe<KpiLevel>;
  segmentIds: Array<Scalars['ID']>;
};


export type QueryListingTypeCountsArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
};


export type QueryListingVolumeGeoMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  zoomLevel: ZoomLevelInput;
};


export type QueryListingVolumeHistogramArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  interval: DateIntervalInput;
  kpiLevel?: InputMaybe<KpiLevel>;
};


export type QueryListingVolumeMetricArgs = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  kpiLevel?: InputMaybe<KpiLevel>;
};


export type QueryListingVolumeMultiMetricArgs = {
  dateRange: DateRangeInput;
  kpiLevel?: InputMaybe<KpiLevel>;
  segmentIds: Array<Scalars['ID']>;
};


export type QueryListingsSnapshotArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMakeModelCountsArgs = {
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  makeName?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySegmentArgs = {
  id: Scalars['ID'];
};


export type QuerySegmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<ListingsCountry>;
  filters?: InputMaybe<Array<InputMaybe<SegmentFilter>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};


export type QuerySystemInviteArgs = {
  id: Scalars['ID'];
};


export type QuerySystemListingsByFieldNameArgs = {
  entries: Array<InputMaybe<Scalars['ID']>>;
  fieldName: Scalars['String'];
};


export type QuerySystemOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemSegmentArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUserArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUserOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};


export type QueryVehiclesSnapshotArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Segment = {
  country: ListingsCountry;
  createdAt?: Maybe<Scalars['Date']>;
  creator?: Maybe<User>;
  dateRange?: Maybe<DateRange>;
  documentUrl?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<ListingFilter>>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  processed?: Maybe<Scalars['Boolean']>;
  processingData?: Maybe<SegmentProcessingData>;
  tag?: Maybe<Tag>;
  type?: Maybe<SegmentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  vinPosition?: Maybe<Scalars['Int']>;
};

export type SegmentConnection = {
  nodes?: Maybe<Array<Maybe<Segment>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SegmentDateFilterInput = {
  field: SegmentFilterDateField;
  values: DateRangeInput;
};

export type SegmentFilter = {
  dateFilter?: InputMaybe<SegmentDateFilterInput>;
  stringFilter?: InputMaybe<SegmentStringFilterInput>;
};

export enum SegmentFilterDateField {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export enum SegmentFilterStringField {
  CreatedByUserId = 'createdByUserId',
  TagId = 'tagId'
}

export type SegmentFromGlobalDbInput = {
  country: ListingsCountry;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  name: Scalars['String'];
};

export type SegmentFromVinsInput = {
  country: ListingsCountry;
  dateRange?: InputMaybe<DateRangeInput>;
  documentUrl: Scalars['String'];
  name: Scalars['String'];
  vinPosition: Scalars['Int'];
};

export type SegmentProcessingData = {
  processedVins?: Maybe<Scalars['Int']>;
  totalVins?: Maybe<Scalars['Int']>;
};

export type SegmentProcessingDataInput = {
  processedVins?: InputMaybe<Scalars['Int']>;
  totalVins?: InputMaybe<Scalars['Int']>;
};

export type SegmentStringFilterInput = {
  field: SegmentFilterStringField;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export enum SegmentType {
  Global = 'Global',
  VinList = 'VinList'
}

export type SegmentUpdateInput = {
  country?: InputMaybe<ListingsCountry>;
  dateRange?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type SortFieldInput = {
  ascending: Scalars['Boolean'];
  field: FilterField;
};

export enum StatusEnum {
  Active = 'ACTIVE',
  Sold = 'SOLD'
}

export type StringFilter = {
  field?: Maybe<FilterStringField>;
  operator?: Maybe<StringOperators>;
};

export type StringFilterConfiguration = {
  condition: LogicalOperator;
};

export type StringFilterInput = {
  field?: InputMaybe<FilterStringField>;
  operator?: InputMaybe<StringOperatorsInput>;
};

export type StringOperators = {
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StringOperatorsInput = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Subscription = {
  _?: Maybe<Scalars['Boolean']>;
  segmentProcessed?: Maybe<Segment>;
};


export type SubscriptionSegmentProcessedArgs = {
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  listingsCountries?: InputMaybe<Array<InputMaybe<ListingsCountry>>>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SystemSegmentUpdateInput = {
  country?: InputMaybe<ListingsCountry>;
  id: Scalars['ID'];
  processed?: InputMaybe<Scalars['Boolean']>;
  processingData?: InputMaybe<SegmentProcessingDataInput>;
};

export type Tag = {
  createdAt?: Maybe<Scalars['Date']>;
  creator?: Maybe<User>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type TagConnection = {
  nodes?: Maybe<Array<Maybe<Tag>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  listingCountries?: InputMaybe<Array<InputMaybe<ListingsCountry>>>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateTagInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type User = {
  admin?: Maybe<Scalars['Boolean']>;
  disableOrgs?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  invites?: Maybe<Array<Maybe<Invite>>>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  phone?: Maybe<Scalars['String']>;
};

export type UserConnection = {
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  cursor: Scalars['String'];
  node?: Maybe<User>;
};

export type UserOrganization = {
  id: Scalars['ID'];
  invite?: Maybe<Invite>;
  organization?: Maybe<Organization>;
  owner: Scalars['Boolean'];
  user?: Maybe<User>;
};

export type UserRole = {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  owner: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum ValueField {
  Certified = 'certified',
  DealerType = 'dealerType'
}

export type Vehicle = {
  certified?: Maybe<Scalars['Boolean']>;
  dealerListingMSRP?: Maybe<Scalars['Float']>;
  dealerType?: Maybe<Scalars['String']>;
  doors?: Maybe<Scalars['Int']>;
  drivetrainFromVin?: Maybe<Scalars['String']>;
  engineFromVin?: Maybe<Scalars['String']>;
  exteriorColor?: Maybe<Scalars['String']>;
  exteriorColorCategory?: Maybe<Scalars['String']>;
  fuelTypeFromVin?: Maybe<Scalars['String']>;
  hasLeather?: Maybe<Scalars['Boolean']>;
  hasNavigation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  intentMsgMileage?: Maybe<Scalars['String']>;
  intentMsgPrice?: Maybe<Scalars['String']>;
  interiorColor?: Maybe<Scalars['String']>;
  interiorColorCategory?: Maybe<Scalars['String']>;
  listedDays?: Maybe<Scalars['Int']>;
  listingDropoffDate?: Maybe<Scalars['Date']>;
  listingFirstDate?: Maybe<Scalars['Date']>;
  listingLastDate?: Maybe<Scalars['Date']>;
  listingType?: Maybe<Scalars['String']>;
  listings?: Maybe<Array<Maybe<Listing>>>;
  listingsCount?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelYear?: Maybe<Scalars['Int']>;
  msrp?: Maybe<Scalars['Float']>;
  optionalFeatures?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  series?: Maybe<Scalars['String']>;
  standardFeatures?: Maybe<Scalars['String']>;
  stockType?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  transmissionFromVin?: Maybe<Scalars['String']>;
  uvc?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  wheelBaseFromVin?: Maybe<Scalars['Float']>;
};

export type VehicleConnection = {
  nodes?: Maybe<Array<Maybe<Vehicle>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ZoomLevelInput {
  State = 'STATE',
  Zipcode = 'ZIPCODE'
}

export type CreateOrganizationMutationVariables = Exact<{
  organization?: InputMaybe<OrganizationInput>;
}>;


export type CreateOrganizationMutation = { createOrganization?: { id: string } | null };

export type FieldValueGeoMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  zoomLevel: ZoomLevelInput;
  field: ValueField;
  value: Scalars['String'];
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type FieldValueGeoMetricQuery = { fieldValueGeoMetric?: { kpi?: string | null, geo?: Array<{ count?: number | null, key?: string | null, valueCount?: number | null } | null> | null, geoResults?: Array<{ count: number, postalCodes: Array<string | null> } | null> | null } | null };

export type FieldValueHistogramQueryVariables = Exact<{
  field: ValueField;
  value: Scalars['String'];
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  dateRange?: InputMaybe<DateRangeInput>;
  country: ListingsCountry;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type FieldValueHistogramQuery = { fieldValueHistogram?: { average?: number | null, histogram?: Array<{ count: number, key: { from: number, to: number } } | null> | null } | null };

export type FieldValueKpiMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  field: ValueField;
  value: Scalars['String'];
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type FieldValueKpiMetricQuery = { fieldValueKpiMetric?: { kpi?: string | null, stats?: { active?: { valueCount?: number | null, count?: number | null } | null, all?: { valueCount?: number | null, count?: number | null } | null, sold?: { valueCount?: number | null, count?: number | null } | null } | null } | null };

export type SendInviteMutationVariables = Exact<{
  inviteParams?: InputMaybe<InviteInput>;
}>;


export type SendInviteMutation = { createInvite?: { id: string, email: string, owner: boolean, organizationId: string, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null, user?: { firstName?: string | null, email?: string | null, lastName?: string | null } | null, organization?: { name?: string | null } | null } | null };

export type DeclineInviteMutationVariables = Exact<{
  declineInviteId: Scalars['ID'];
}>;


export type DeclineInviteMutation = { declineInvite?: { status: string, organizationId: string } | null };

export type AcceptInviteMutationVariables = Exact<{
  acceptInviteId: Scalars['ID'];
}>;


export type AcceptInviteMutation = { acceptInvite?: { organizationId: string, status: string } | null };

export type KpiGeoMetricsQueryVariables = Exact<{
  kpi: FilterNumberField;
  dateRange: DateRangeInput;
  zoomLevel: ZoomLevelInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type KpiGeoMetricsQuery = { kpiGeoMetrics?: { kpi?: string | null, geo?: Array<{ count?: number | null, key?: string | null, avg?: { value?: number | null } | null } | null> | null, geoResults?: Array<{ count: number, postalCodes: Array<string | null> } | null> | null } | null };

export type KpiHistogramQueryVariables = Exact<{
  field: FilterNumberField;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['Int']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  dateRange?: InputMaybe<DateRangeInput>;
  country: ListingsCountry;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type KpiHistogramQuery = { kpiHistogram?: { average?: number | null, histogram?: Array<{ count: number, key: { from: number, to: number } } | null> | null } | null };

export type KpiMultiMetricQueryVariables = Exact<{
  segmentIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRangeInput;
  kpi: FilterNumberField;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type KpiMultiMetricQuery = { kpiMultiMetric?: Array<{ segmentId?: string | null, kpi?: string | null, stats?: { active?: { percentageChange?: number | null, count?: number | null, avg?: { value?: number | null } | null } | null, all?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null, sold?: { percentageChange?: number | null, count?: number | null, avg?: { value?: number | null } | null } | null } | null } | null> | null };

export type ListingVolumeMultiMetricQueryVariables = Exact<{
  segmentIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRangeInput;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingVolumeMultiMetricQuery = { listingVolumeMultiMetric?: Array<{ segmentId?: string | null, kpi?: string | null, stats?: { active?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null, all?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null, sold?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null } | null } | null> | null };

export type ListingDaysOnMarketMultiMetricQueryVariables = Exact<{
  segmentIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRangeInput;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingDaysOnMarketMultiMetricQuery = { listingDaysOnMarketMultiMetric?: Array<{ kpi?: string | null, segmentId?: string | null, stats?: { active?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null, all?: { percentageChange?: number | null, count?: number | null, avg?: { value?: number | null } | null } | null, sold?: { percentageChange?: number | null, count?: number | null, avg?: { value?: number | null } | null } | null } | null } | null> | null };

export type FieldValueMultiMetricQueryVariables = Exact<{
  segmentIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRangeInput;
  field: ValueField;
  value: Scalars['String'];
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type FieldValueMultiMetricQuery = { fieldValueMultiMetric?: Array<{ kpi?: string | null, segmentId?: string | null, stats?: { sold?: { valueCount?: number | null, count?: number | null } | null, all?: { valueCount?: number | null, count?: number | null } | null, active?: { valueCount?: number | null, count?: number | null } | null } | null } | null> | null };

export type ListingMarketDaysSupplyMultiMetricQueryVariables = Exact<{
  segmentIds: Array<Scalars['ID']> | Scalars['ID'];
  dateRange: DateRangeInput;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingMarketDaysSupplyMultiMetricQuery = { listingMarketDaysSupplyMultiMetric?: Array<{ kpi?: string | null, segmentId?: string | null, value?: number | null } | null> | null };

export type KpiListQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiListQuery = { kpiList?: Array<{ title?: string | null, filterField?: string | null } | null> | null };

export type KpiMetricsQueryVariables = Exact<{
  kpi: FilterNumberField;
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  country: ListingsCountry;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type KpiMetricsQuery = { kpiMetrics?: { kpi?: string | null, stats?: { sold?: { count?: number | null, avg?: { value?: number | null } | null } | null, active?: { count?: number | null, avg?: { value?: number | null } | null } | null, all?: { count?: number | null, avg?: { value?: number | null } | null } | null } | null } | null };

export type KpiDaysOnMarketQueryVariables = Exact<{
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  country: ListingsCountry;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type KpiDaysOnMarketQuery = { kpiDaysOnMarket?: { kpi?: string | null, stats?: { active?: { percentageChange?: number | null, count?: number | null, avg?: { value?: number | null } | null } | null, sold?: { percentageChange?: number | null, count?: number | null, avg?: { value?: number | null } | null } | null, all?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null } | null } | null };

export type ListingVolumeMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingVolumeMetricQuery = { listingVolumeMetric?: { kpi?: string | null, stats?: { sold?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null, all?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null, active?: { count?: number | null, percentageChange?: number | null, avg?: { value?: number | null } | null } | null } | null } | null };

export type ListingFieldHistogramQueryVariables = Exact<{
  interval: DateIntervalInput;
  dateRange: DateRangeInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
  field: FilterNumberField;
}>;


export type ListingFieldHistogramQuery = { listingFieldHistogram?: Array<{ key: string, count: number } | null> | null };

export type ListingFieldsQueryVariables = Exact<{
  makeFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ListingFieldsQuery = { listingFields?: Array<{ filterField: FilterField, title: string, type: FieldType, configuration?: { numberFilterConfiguration?: { from?: number | null, to?: number | null, unit?: string | null } | null, stringFilterConfiguration?: { condition: LogicalOperator } | null, modelFilterConfiguration?: { make?: string | null } | null } | null } | null> | null };

export type FieldCountsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  propertyName?: InputMaybe<CountField>;
  dateRange?: InputMaybe<DateRangeInput>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  country: ListingsCountry;
}>;


export type FieldCountsQuery = { fieldCounts: { totalCount: number, nodes?: Array<{ count: number, key: string } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type MakeModelCountsQueryVariables = Exact<{
  makeName?: InputMaybe<Scalars['String']>;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type MakeModelCountsQuery = { makeModelCounts?: Array<{ count: number, key: string } | null> | null };

export type ListingMarketDaysSupplyGeoMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  zoomLevel: ZoomLevelInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingMarketDaysSupplyGeoMetricQuery = { listingMarketDaysSupplyGeoMetric?: { kpi?: string | null, geoResults?: Array<{ count: number, postalCodes: Array<string | null> } | null> | null, geo?: Array<{ key?: string | null, value?: number | null } | null> | null } | null };

export type ListingMarketDaysSupplyMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  country: ListingsCountry;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingMarketDaysSupplyMetricQuery = { listingMarketDaysSupplyMetric?: { kpi?: string | null, value?: number | null } | null };

export type ListingTypeCountsQueryVariables = Exact<{
  dateRange: DateRangeInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
}>;


export type ListingTypeCountsQuery = { listingTypeCounts?: Array<{ count: number, key: string } | null> | null };

export type ListingVolumeGeoMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  zoomLevel: ZoomLevelInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingVolumeGeoMetricQuery = { listingVolumeGeoMetric?: { kpi?: string | null, geo?: Array<{ count?: number | null, key?: string | null, avg?: { value?: number | null } | null } | null> | null, geoResults?: Array<{ postalCodes: Array<string | null>, count: number } | null> | null } | null };

export type ListingVolumeHistogramQueryVariables = Exact<{
  interval: DateIntervalInput;
  dateRange: DateRangeInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingVolumeHistogramQuery = { listingVolumeHistogram?: Array<{ key: string, count: number } | null> | null };

export type ListingsDaysOnMarketGeoMetricQueryVariables = Exact<{
  dateRange: DateRangeInput;
  zoomLevel: ZoomLevelInput;
  country: ListingsCountry;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingsDaysOnMarketGeoMetricQuery = { listingDaysOnMarketGeoMetric?: { kpi?: string | null, geo?: Array<{ count?: number | null, key?: string | null, avg?: { value?: number | null } | null } | null> | null, geoResults?: Array<{ count: number, postalCodes: Array<string | null> } | null> | null } | null };

export type ListingDaysOnMarketHistogramQueryVariables = Exact<{
  interval?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  minCountPerBucket?: InputMaybe<Scalars['Int']>;
  dateRange?: InputMaybe<DateRangeInput>;
  country: ListingsCountry;
  kpiLevel?: InputMaybe<KpiLevel>;
}>;


export type ListingDaysOnMarketHistogramQuery = { listingDaysOnMarketHistogram?: { average?: number | null, histogram?: Array<{ count: number, key: { from: number, to: number } } | null> | null } | null };

export type ListingsSnapshotQueryVariables = Exact<{
  country: ListingsCountry;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type ListingsSnapshotQuery = { listingsSnapshot: { totalCount: number } };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationQuery = { organization?: { addressLine1?: string | null, state?: string | null, id: string, name?: string | null, country?: string | null, city?: string | null, phone?: string | null, owned?: boolean | null, zip?: string | null, seatsTaken?: number | null, totalSeats?: number | null, listingsCountries?: Array<ListingsCountry | null> | null, imageUrl?: string | null, createdAt?: any | null, userRoles?: Array<{ id: string } | null> | null } | null };

export type EditOrganizationMutationVariables = Exact<{
  updateOrganizationId?: InputMaybe<Scalars['ID']>;
  organization?: InputMaybe<OrganizationInput>;
}>;


export type EditOrganizationMutation = { updateOrganization?: { id: string } | null };

export type AdminUpdateOrganizationMutationVariables = Exact<{
  input: AdminUpdateOrganizationInput;
}>;


export type AdminUpdateOrganizationMutation = { adminUpdateOrganization?: { id: string } | null };

export type InvitesOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type InvitesOrganizationQuery = { organization?: { pendingInvites?: Array<{ id: string, email: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type DeleteSentInviteMutationVariables = Exact<{
  deleteInviteId: Scalars['ID'];
}>;


export type DeleteSentInviteMutation = { deleteInvite?: { status: string } | null };

export type ResendSentInviteMutationVariables = Exact<{
  resendInviteId: Scalars['ID'];
}>;


export type ResendSentInviteMutation = { resendInvite?: { status: string } | null };

export type MembersOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type MembersOrganizationQuery = { organization?: { userRoles?: Array<{ id: string, owner: boolean, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null } | null> | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveMemberMutation = { removeMember?: boolean | null };

export type OrganizationNameImageQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationNameImageQuery = { organization?: { name?: string | null, imageUrl?: string | null } | null };

export type SegmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<SegmentFilter>> | InputMaybe<SegmentFilter>>;
}>;


export type SegmentsQuery = { segments?: { totalCount: number, nodes?: Array<{ id: string, name?: string | null, processed?: boolean | null, createdAt?: any | null, updatedAt?: any | null, type?: SegmentType | null, country: ListingsCountry, creator?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null, tag?: { id: string, name: string } | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CreateSegmentFromVinsMutationVariables = Exact<{
  segment?: InputMaybe<SegmentFromVinsInput>;
}>;


export type CreateSegmentFromVinsMutation = { createSegmentFromVins?: { createdAt?: any | null, id: string, name?: string | null, documentUrl?: string | null, vinPosition?: number | null, updatedAt?: any | null, creator?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, disableOrgs?: boolean | null } | null } | null };

export type CreateSegmentFromGlobalDbMutationVariables = Exact<{
  segment?: InputMaybe<SegmentFromGlobalDbInput>;
}>;


export type CreateSegmentFromGlobalDbMutation = { createSegmentFromGlobalDb?: { id: string } | null };

export type SegmentQueryVariables = Exact<{
  segmentId: Scalars['ID'];
}>;


export type SegmentQuery = { segment?: { name?: string | null, id: string, updatedAt?: any | null, type?: SegmentType | null, country: ListingsCountry, creator?: { id: string, firstName?: string | null, lastName?: string | null } | null, filters?: Array<{ numberFilter?: { field?: FilterNumberField | null, operator?: { eq?: number | null, in?: Array<number | null> | null, lt?: number | null, lte?: number | null, gt?: number | null, gte?: number | null, between?: { to?: number | null, from?: number | null } | null } | null } | null, stringFilter?: { field?: FilterStringField | null, operator?: { eq?: string | null, in?: Array<string | null> | null } | null } | null, booleanFilter?: { field?: string | null, operator?: { eq?: boolean | null } | null } | null, dateFilter?: { field?: FilterDateField | null, operator?: { lt?: any | null, lte?: any | null, gt?: any | null, gte?: any | null, between?: { to: any, from: any } | null } | null } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { region?: string | null, distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, makeModelFilter?: { combinations: Array<{ make: string, model: Array<string> }> } | null } | null> | null, dateRange?: { from: any, to: any } | null } | null };

export type UpdateSegmentMutationVariables = Exact<{
  input: SegmentUpdateInput;
}>;


export type UpdateSegmentMutation = { updateSegment?: { id: string } | null };

export type DeleteSegmentMutationVariables = Exact<{
  deleteSegmentId: Scalars['ID'];
}>;


export type DeleteSegmentMutation = { deleteSegment?: { id: string } | null };

export type SegmentProcessedSubscriptionVariables = Exact<{
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type SegmentProcessedSubscription = { segmentProcessed?: { name?: string | null, id: string, updatedAt?: any | null, type?: SegmentType | null, country: ListingsCountry, processed?: boolean | null, creator?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null, filters?: Array<{ numberFilter?: { field?: FilterNumberField | null, operator?: { eq?: number | null, in?: Array<number | null> | null, lt?: number | null, lte?: number | null, gt?: number | null, gte?: number | null, between?: { to?: number | null, from?: number | null } | null } | null } | null, stringFilter?: { field?: FilterStringField | null, operator?: { eq?: string | null, in?: Array<string | null> | null } | null } | null, booleanFilter?: { field?: string | null, operator?: { eq?: boolean | null } | null } | null, dateFilter?: { field?: FilterDateField | null, operator?: { lt?: any | null, lte?: any | null, gt?: any | null, gte?: any | null, between?: { to: any, from: any } | null } | null } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { region?: string | null, distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, makeModelFilter?: { combinations: Array<{ make: string, model: Array<string> }> } | null } | null> | null, dateRange?: { from: any, to: any } | null } | null };

export type TagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  searchString?: InputMaybe<Scalars['String']>;
}>;


export type TagsQuery = { tags?: { totalCount: number, nodes?: Array<{ name: string, id: string } | null> | null, pageInfo: { hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type CreateTagMutationVariables = Exact<{
  input?: InputMaybe<CreateTagInput>;
}>;


export type CreateTagMutation = { createTag?: { id: string } | null };

export type TagSegmentMutationVariables = Exact<{
  tagId: Scalars['ID'];
  tagSegmentId: Scalars['ID'];
}>;


export type TagSegmentMutation = { tagSegment?: { id: string } | null };

export type UntagSegmentMutationVariables = Exact<{
  untagSegmentId: Scalars['ID'];
}>;


export type UntagSegmentMutation = { untagSegment?: { id: string } | null };

export type UpdateTagMutationVariables = Exact<{
  input?: InputMaybe<UpdateTagInput>;
}>;


export type UpdateTagMutation = { updateTag?: { id: string } | null };

export type DeleteTagMutationVariables = Exact<{
  deleteTagId: Scalars['ID'];
}>;


export type DeleteTagMutation = { deleteTag?: { id: string } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, admin?: boolean | null, disableOrgs?: boolean | null, organizations?: Array<{ id: string, name?: string | null, legalName?: string | null, addressLine1?: string | null, addressLine2?: string | null, state?: string | null, zip?: string | null, country?: string | null, city?: string | null, imageUrl?: string | null, phone?: string | null, createdAt?: any | null, updatedAt?: any | null, owned?: boolean | null, listingsCountries?: Array<ListingsCountry | null> | null, userRoles?: Array<{ id: string, owner: boolean, createdAt?: string | null, updatedAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null } | null> | null, pendingInvites?: Array<{ id: string, email: string, owner: boolean, organizationId: string, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null } | null> | null } | null> | null, invites?: Array<{ id: string, email: string, owner: boolean, organizationId: string, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, disableOrgs?: boolean | null } | null, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, disableOrgs?: boolean | null } | null, organization?: { id: string, name?: string | null, legalName?: string | null, addressLine1?: string | null, addressLine2?: string | null, state?: string | null, zip?: string | null, country?: string | null, city?: string | null, imageUrl?: string | null, phone?: string | null, createdAt?: any | null, updatedAt?: any | null, owned?: boolean | null } | null } | null> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  user?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateMeMutation = { updateMe?: { firstName?: string | null, lastName?: string | null } | null };

export type VehiclesSnapshotQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<ListingFilterInput>> | InputMaybe<ListingFilterInput>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  dateRange: DateRangeInput;
  country: ListingsCountry;
  getListings: Scalars['Boolean'];
}>;


export type VehiclesSnapshotQuery = { vehiclesSnapshot: { totalCount: number, nodes?: Array<{ listingType?: string | null, vin?: string | null, stockType?: string | null, fuelTypeFromVin?: string | null, dealerType?: string | null, listingFirstDate?: any | null, listingDropoffDate?: any | null, hasNavigation?: boolean | null, hasLeather?: boolean | null, certified?: boolean | null, make?: string | null, model?: string | null, modelYear?: number | null, series?: string | null, style?: string | null, transmissionFromVin?: string | null, listingsCount?: number | null, uvc?: string | null, mileage?: number | null, price?: number | null, msrp?: number | null, dealerListingMSRP?: number | null, listings?: Array<{ listingFirstDate?: any | null, listingLastDate?: any | null, listingDropoffDate?: any | null, listingUrl?: string | null, listingType?: string | null, dealerName?: string | null, dealerStreet?: string | null, dealerCity?: string | null, dealerState?: string | null, dealerZipcode?: string | null, dealerUrl?: string | null, dealerPhone?: string | null, vin?: string | null, stockType?: string | null, price?: number | null, intentMsgPrice?: string | null, msrp?: number | null, dealerListingMSRP?: number | null, mileage?: number | null, intentMsgMileage?: string | null, fuelTypeFromVin?: string | null, numberPriceChanges?: number | null, dealerType?: string | null, hasNavigation?: boolean | null, hasLeather?: boolean | null, certified?: boolean | null, locationScore?: number | null, make?: string | null, model?: string | null, modelYear?: number | null, series?: string | null, style?: string | null, transmissionFromVin?: string | null, uvc?: string | null, listedDays?: number | null, priceHistory?: Array<{ price?: number | null, updatedAt?: any | null } | null> | null } | null> | null } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };


export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($organization: OrganizationInput) {
  createOrganization(organization: $organization) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const FieldValueGeoMetricDocument = gql`
    query FieldValueGeoMetric($dateRange: DateRangeInput!, $zoomLevel: ZoomLevelInput!, $field: ValueField!, $value: String!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  fieldValueGeoMetric(
    dateRange: $dateRange
    zoomLevel: $zoomLevel
    field: $field
    value: $value
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    kpi
    geo {
      count
      key
      valueCount
    }
    geoResults {
      count
      postalCodes
    }
  }
}
    `;

/**
 * __useFieldValueGeoMetricQuery__
 *
 * To run a query within a React component, call `useFieldValueGeoMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldValueGeoMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldValueGeoMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      zoomLevel: // value for 'zoomLevel'
 *      field: // value for 'field'
 *      value: // value for 'value'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useFieldValueGeoMetricQuery(baseOptions: Apollo.QueryHookOptions<FieldValueGeoMetricQuery, FieldValueGeoMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldValueGeoMetricQuery, FieldValueGeoMetricQueryVariables>(FieldValueGeoMetricDocument, options);
      }
export function useFieldValueGeoMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldValueGeoMetricQuery, FieldValueGeoMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldValueGeoMetricQuery, FieldValueGeoMetricQueryVariables>(FieldValueGeoMetricDocument, options);
        }
export type FieldValueGeoMetricQueryHookResult = ReturnType<typeof useFieldValueGeoMetricQuery>;
export type FieldValueGeoMetricLazyQueryHookResult = ReturnType<typeof useFieldValueGeoMetricLazyQuery>;
export type FieldValueGeoMetricQueryResult = Apollo.QueryResult<FieldValueGeoMetricQuery, FieldValueGeoMetricQueryVariables>;
export const FieldValueHistogramDocument = gql`
    query FieldValueHistogram($field: ValueField!, $value: String!, $filters: [ListingFilterInput], $dateRange: DateRangeInput, $country: ListingsCountry!, $kpiLevel: KpiLevel) {
  fieldValueHistogram(
    field: $field
    value: $value
    filters: $filters
    dateRange: $dateRange
    country: $country
    kpiLevel: $kpiLevel
  ) {
    average
    histogram {
      count
      key {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useFieldValueHistogramQuery__
 *
 * To run a query within a React component, call `useFieldValueHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldValueHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldValueHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      value: // value for 'value'
 *      filters: // value for 'filters'
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useFieldValueHistogramQuery(baseOptions: Apollo.QueryHookOptions<FieldValueHistogramQuery, FieldValueHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldValueHistogramQuery, FieldValueHistogramQueryVariables>(FieldValueHistogramDocument, options);
      }
export function useFieldValueHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldValueHistogramQuery, FieldValueHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldValueHistogramQuery, FieldValueHistogramQueryVariables>(FieldValueHistogramDocument, options);
        }
export type FieldValueHistogramQueryHookResult = ReturnType<typeof useFieldValueHistogramQuery>;
export type FieldValueHistogramLazyQueryHookResult = ReturnType<typeof useFieldValueHistogramLazyQuery>;
export type FieldValueHistogramQueryResult = Apollo.QueryResult<FieldValueHistogramQuery, FieldValueHistogramQueryVariables>;
export const FieldValueKpiMetricDocument = gql`
    query FieldValueKpiMetric($dateRange: DateRangeInput!, $field: ValueField!, $value: String!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  fieldValueKpiMetric(
    dateRange: $dateRange
    field: $field
    value: $value
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    kpi
    stats {
      active {
        valueCount
        count
      }
      all {
        valueCount
        count
      }
      sold {
        valueCount
        count
      }
    }
  }
}
    `;

/**
 * __useFieldValueKpiMetricQuery__
 *
 * To run a query within a React component, call `useFieldValueKpiMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldValueKpiMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldValueKpiMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      field: // value for 'field'
 *      value: // value for 'value'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useFieldValueKpiMetricQuery(baseOptions: Apollo.QueryHookOptions<FieldValueKpiMetricQuery, FieldValueKpiMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldValueKpiMetricQuery, FieldValueKpiMetricQueryVariables>(FieldValueKpiMetricDocument, options);
      }
export function useFieldValueKpiMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldValueKpiMetricQuery, FieldValueKpiMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldValueKpiMetricQuery, FieldValueKpiMetricQueryVariables>(FieldValueKpiMetricDocument, options);
        }
export type FieldValueKpiMetricQueryHookResult = ReturnType<typeof useFieldValueKpiMetricQuery>;
export type FieldValueKpiMetricLazyQueryHookResult = ReturnType<typeof useFieldValueKpiMetricLazyQuery>;
export type FieldValueKpiMetricQueryResult = Apollo.QueryResult<FieldValueKpiMetricQuery, FieldValueKpiMetricQueryVariables>;
export const SendInviteDocument = gql`
    mutation SendInvite($inviteParams: InviteInput) {
  createInvite(inviteParams: $inviteParams) {
    id
    email
    owner
    organizationId
    createdByUserId
    status
    createdAt
    updatedAt
    acceptedAt
    declinedAt
    deletedAt
    inviter {
      firstName
      lastName
      email
    }
    user {
      firstName
      email
      lastName
    }
    organization {
      name
    }
  }
}
    `;
export type SendInviteMutationFn = Apollo.MutationFunction<SendInviteMutation, SendInviteMutationVariables>;

/**
 * __useSendInviteMutation__
 *
 * To run a mutation, you first call `useSendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteMutation, { data, loading, error }] = useSendInviteMutation({
 *   variables: {
 *      inviteParams: // value for 'inviteParams'
 *   },
 * });
 */
export function useSendInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteMutation, SendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, options);
      }
export type SendInviteMutationHookResult = ReturnType<typeof useSendInviteMutation>;
export type SendInviteMutationResult = Apollo.MutationResult<SendInviteMutation>;
export type SendInviteMutationOptions = Apollo.BaseMutationOptions<SendInviteMutation, SendInviteMutationVariables>;
export const DeclineInviteDocument = gql`
    mutation DeclineInvite($declineInviteId: ID!) {
  declineInvite(id: $declineInviteId) {
    status
    organizationId
  }
}
    `;
export type DeclineInviteMutationFn = Apollo.MutationFunction<DeclineInviteMutation, DeclineInviteMutationVariables>;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInviteMutation, { data, loading, error }] = useDeclineInviteMutation({
 *   variables: {
 *      declineInviteId: // value for 'declineInviteId'
 *   },
 * });
 */
export function useDeclineInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineInviteMutation, DeclineInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(DeclineInviteDocument, options);
      }
export type DeclineInviteMutationHookResult = ReturnType<typeof useDeclineInviteMutation>;
export type DeclineInviteMutationResult = Apollo.MutationResult<DeclineInviteMutation>;
export type DeclineInviteMutationOptions = Apollo.BaseMutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($acceptInviteId: ID!) {
  acceptInvite(id: $acceptInviteId) {
    organizationId
    status
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInviteId: // value for 'acceptInviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const KpiGeoMetricsDocument = gql`
    query KpiGeoMetrics($kpi: FilterNumberField!, $dateRange: DateRangeInput!, $zoomLevel: ZoomLevelInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  kpiGeoMetrics(
    kpi: $kpi
    dateRange: $dateRange
    zoomLevel: $zoomLevel
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    geo {
      avg {
        value
      }
      count
      key
    }
    geoResults {
      count
      postalCodes
    }
    kpi
  }
}
    `;

/**
 * __useKpiGeoMetricsQuery__
 *
 * To run a query within a React component, call `useKpiGeoMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiGeoMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiGeoMetricsQuery({
 *   variables: {
 *      kpi: // value for 'kpi'
 *      dateRange: // value for 'dateRange'
 *      zoomLevel: // value for 'zoomLevel'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useKpiGeoMetricsQuery(baseOptions: Apollo.QueryHookOptions<KpiGeoMetricsQuery, KpiGeoMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiGeoMetricsQuery, KpiGeoMetricsQueryVariables>(KpiGeoMetricsDocument, options);
      }
export function useKpiGeoMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiGeoMetricsQuery, KpiGeoMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiGeoMetricsQuery, KpiGeoMetricsQueryVariables>(KpiGeoMetricsDocument, options);
        }
export type KpiGeoMetricsQueryHookResult = ReturnType<typeof useKpiGeoMetricsQuery>;
export type KpiGeoMetricsLazyQueryHookResult = ReturnType<typeof useKpiGeoMetricsLazyQuery>;
export type KpiGeoMetricsQueryResult = Apollo.QueryResult<KpiGeoMetricsQuery, KpiGeoMetricsQueryVariables>;
export const KpiHistogramDocument = gql`
    query KpiHistogram($field: FilterNumberField!, $max: Int, $min: Int, $interval: Int, $minCountPerBucket: Int, $filters: [ListingFilterInput], $dateRange: DateRangeInput, $country: ListingsCountry!, $kpiLevel: KpiLevel) {
  kpiHistogram(
    field: $field
    max: $max
    min: $min
    interval: $interval
    minCountPerBucket: $minCountPerBucket
    filters: $filters
    dateRange: $dateRange
    country: $country
    kpiLevel: $kpiLevel
  ) {
    average
    histogram {
      count
      key {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useKpiHistogramQuery__
 *
 * To run a query within a React component, call `useKpiHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      max: // value for 'max'
 *      min: // value for 'min'
 *      interval: // value for 'interval'
 *      minCountPerBucket: // value for 'minCountPerBucket'
 *      filters: // value for 'filters'
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useKpiHistogramQuery(baseOptions: Apollo.QueryHookOptions<KpiHistogramQuery, KpiHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiHistogramQuery, KpiHistogramQueryVariables>(KpiHistogramDocument, options);
      }
export function useKpiHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiHistogramQuery, KpiHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiHistogramQuery, KpiHistogramQueryVariables>(KpiHistogramDocument, options);
        }
export type KpiHistogramQueryHookResult = ReturnType<typeof useKpiHistogramQuery>;
export type KpiHistogramLazyQueryHookResult = ReturnType<typeof useKpiHistogramLazyQuery>;
export type KpiHistogramQueryResult = Apollo.QueryResult<KpiHistogramQuery, KpiHistogramQueryVariables>;
export const KpiMultiMetricDocument = gql`
    query KpiMultiMetric($segmentIds: [ID!]!, $dateRange: DateRangeInput!, $kpi: FilterNumberField!, $kpiLevel: KpiLevel) {
  kpiMultiMetric(
    segmentIds: $segmentIds
    dateRange: $dateRange
    kpi: $kpi
    kpiLevel: $kpiLevel
  ) {
    segmentId
    kpi
    stats {
      active {
        percentageChange
        avg {
          value
        }
        count
      }
      all {
        count
        percentageChange
        avg {
          value
        }
      }
      sold {
        percentageChange
        count
        avg {
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKpiMultiMetricQuery__
 *
 * To run a query within a React component, call `useKpiMultiMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiMultiMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiMultiMetricQuery({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *      dateRange: // value for 'dateRange'
 *      kpi: // value for 'kpi'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useKpiMultiMetricQuery(baseOptions: Apollo.QueryHookOptions<KpiMultiMetricQuery, KpiMultiMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiMultiMetricQuery, KpiMultiMetricQueryVariables>(KpiMultiMetricDocument, options);
      }
export function useKpiMultiMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiMultiMetricQuery, KpiMultiMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiMultiMetricQuery, KpiMultiMetricQueryVariables>(KpiMultiMetricDocument, options);
        }
export type KpiMultiMetricQueryHookResult = ReturnType<typeof useKpiMultiMetricQuery>;
export type KpiMultiMetricLazyQueryHookResult = ReturnType<typeof useKpiMultiMetricLazyQuery>;
export type KpiMultiMetricQueryResult = Apollo.QueryResult<KpiMultiMetricQuery, KpiMultiMetricQueryVariables>;
export const ListingVolumeMultiMetricDocument = gql`
    query ListingVolumeMultiMetric($segmentIds: [ID!]!, $dateRange: DateRangeInput!, $kpiLevel: KpiLevel) {
  listingVolumeMultiMetric(
    segmentIds: $segmentIds
    dateRange: $dateRange
    kpiLevel: $kpiLevel
  ) {
    segmentId
    kpi
    stats {
      active {
        count
        percentageChange
        avg {
          value
        }
      }
      all {
        avg {
          value
        }
        count
        percentageChange
      }
      sold {
        avg {
          value
        }
        count
        percentageChange
      }
    }
  }
}
    `;

/**
 * __useListingVolumeMultiMetricQuery__
 *
 * To run a query within a React component, call `useListingVolumeMultiMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingVolumeMultiMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingVolumeMultiMetricQuery({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *      dateRange: // value for 'dateRange'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingVolumeMultiMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingVolumeMultiMetricQuery, ListingVolumeMultiMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingVolumeMultiMetricQuery, ListingVolumeMultiMetricQueryVariables>(ListingVolumeMultiMetricDocument, options);
      }
export function useListingVolumeMultiMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingVolumeMultiMetricQuery, ListingVolumeMultiMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingVolumeMultiMetricQuery, ListingVolumeMultiMetricQueryVariables>(ListingVolumeMultiMetricDocument, options);
        }
export type ListingVolumeMultiMetricQueryHookResult = ReturnType<typeof useListingVolumeMultiMetricQuery>;
export type ListingVolumeMultiMetricLazyQueryHookResult = ReturnType<typeof useListingVolumeMultiMetricLazyQuery>;
export type ListingVolumeMultiMetricQueryResult = Apollo.QueryResult<ListingVolumeMultiMetricQuery, ListingVolumeMultiMetricQueryVariables>;
export const ListingDaysOnMarketMultiMetricDocument = gql`
    query ListingDaysOnMarketMultiMetric($segmentIds: [ID!]!, $dateRange: DateRangeInput!, $kpiLevel: KpiLevel) {
  listingDaysOnMarketMultiMetric(
    segmentIds: $segmentIds
    dateRange: $dateRange
    kpiLevel: $kpiLevel
  ) {
    kpi
    segmentId
    stats {
      active {
        avg {
          value
        }
        count
        percentageChange
      }
      all {
        percentageChange
        count
        avg {
          value
        }
      }
      sold {
        percentageChange
        count
        avg {
          value
        }
      }
    }
  }
}
    `;

/**
 * __useListingDaysOnMarketMultiMetricQuery__
 *
 * To run a query within a React component, call `useListingDaysOnMarketMultiMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingDaysOnMarketMultiMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingDaysOnMarketMultiMetricQuery({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *      dateRange: // value for 'dateRange'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingDaysOnMarketMultiMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingDaysOnMarketMultiMetricQuery, ListingDaysOnMarketMultiMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingDaysOnMarketMultiMetricQuery, ListingDaysOnMarketMultiMetricQueryVariables>(ListingDaysOnMarketMultiMetricDocument, options);
      }
export function useListingDaysOnMarketMultiMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingDaysOnMarketMultiMetricQuery, ListingDaysOnMarketMultiMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingDaysOnMarketMultiMetricQuery, ListingDaysOnMarketMultiMetricQueryVariables>(ListingDaysOnMarketMultiMetricDocument, options);
        }
export type ListingDaysOnMarketMultiMetricQueryHookResult = ReturnType<typeof useListingDaysOnMarketMultiMetricQuery>;
export type ListingDaysOnMarketMultiMetricLazyQueryHookResult = ReturnType<typeof useListingDaysOnMarketMultiMetricLazyQuery>;
export type ListingDaysOnMarketMultiMetricQueryResult = Apollo.QueryResult<ListingDaysOnMarketMultiMetricQuery, ListingDaysOnMarketMultiMetricQueryVariables>;
export const FieldValueMultiMetricDocument = gql`
    query FieldValueMultiMetric($segmentIds: [ID!]!, $dateRange: DateRangeInput!, $field: ValueField!, $value: String!, $kpiLevel: KpiLevel) {
  fieldValueMultiMetric(
    segmentIds: $segmentIds
    dateRange: $dateRange
    field: $field
    value: $value
    kpiLevel: $kpiLevel
  ) {
    kpi
    segmentId
    stats {
      sold {
        valueCount
        count
      }
      all {
        valueCount
        count
      }
      active {
        valueCount
        count
      }
    }
  }
}
    `;

/**
 * __useFieldValueMultiMetricQuery__
 *
 * To run a query within a React component, call `useFieldValueMultiMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldValueMultiMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldValueMultiMetricQuery({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *      dateRange: // value for 'dateRange'
 *      field: // value for 'field'
 *      value: // value for 'value'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useFieldValueMultiMetricQuery(baseOptions: Apollo.QueryHookOptions<FieldValueMultiMetricQuery, FieldValueMultiMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldValueMultiMetricQuery, FieldValueMultiMetricQueryVariables>(FieldValueMultiMetricDocument, options);
      }
export function useFieldValueMultiMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldValueMultiMetricQuery, FieldValueMultiMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldValueMultiMetricQuery, FieldValueMultiMetricQueryVariables>(FieldValueMultiMetricDocument, options);
        }
export type FieldValueMultiMetricQueryHookResult = ReturnType<typeof useFieldValueMultiMetricQuery>;
export type FieldValueMultiMetricLazyQueryHookResult = ReturnType<typeof useFieldValueMultiMetricLazyQuery>;
export type FieldValueMultiMetricQueryResult = Apollo.QueryResult<FieldValueMultiMetricQuery, FieldValueMultiMetricQueryVariables>;
export const ListingMarketDaysSupplyMultiMetricDocument = gql`
    query ListingMarketDaysSupplyMultiMetric($segmentIds: [ID!]!, $dateRange: DateRangeInput!, $kpiLevel: KpiLevel) {
  listingMarketDaysSupplyMultiMetric(
    segmentIds: $segmentIds
    dateRange: $dateRange
    kpiLevel: $kpiLevel
  ) {
    kpi
    segmentId
    value
  }
}
    `;

/**
 * __useListingMarketDaysSupplyMultiMetricQuery__
 *
 * To run a query within a React component, call `useListingMarketDaysSupplyMultiMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingMarketDaysSupplyMultiMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingMarketDaysSupplyMultiMetricQuery({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *      dateRange: // value for 'dateRange'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingMarketDaysSupplyMultiMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingMarketDaysSupplyMultiMetricQuery, ListingMarketDaysSupplyMultiMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingMarketDaysSupplyMultiMetricQuery, ListingMarketDaysSupplyMultiMetricQueryVariables>(ListingMarketDaysSupplyMultiMetricDocument, options);
      }
export function useListingMarketDaysSupplyMultiMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingMarketDaysSupplyMultiMetricQuery, ListingMarketDaysSupplyMultiMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingMarketDaysSupplyMultiMetricQuery, ListingMarketDaysSupplyMultiMetricQueryVariables>(ListingMarketDaysSupplyMultiMetricDocument, options);
        }
export type ListingMarketDaysSupplyMultiMetricQueryHookResult = ReturnType<typeof useListingMarketDaysSupplyMultiMetricQuery>;
export type ListingMarketDaysSupplyMultiMetricLazyQueryHookResult = ReturnType<typeof useListingMarketDaysSupplyMultiMetricLazyQuery>;
export type ListingMarketDaysSupplyMultiMetricQueryResult = Apollo.QueryResult<ListingMarketDaysSupplyMultiMetricQuery, ListingMarketDaysSupplyMultiMetricQueryVariables>;
export const KpiListDocument = gql`
    query KpiList {
  kpiList {
    title
    filterField
  }
}
    `;

/**
 * __useKpiListQuery__
 *
 * To run a query within a React component, call `useKpiListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKpiListQuery(baseOptions?: Apollo.QueryHookOptions<KpiListQuery, KpiListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiListQuery, KpiListQueryVariables>(KpiListDocument, options);
      }
export function useKpiListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiListQuery, KpiListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiListQuery, KpiListQueryVariables>(KpiListDocument, options);
        }
export type KpiListQueryHookResult = ReturnType<typeof useKpiListQuery>;
export type KpiListLazyQueryHookResult = ReturnType<typeof useKpiListLazyQuery>;
export type KpiListQueryResult = Apollo.QueryResult<KpiListQuery, KpiListQueryVariables>;
export const KpiMetricsDocument = gql`
    query KpiMetrics($kpi: FilterNumberField!, $dateRange: DateRangeInput!, $filters: [ListingFilterInput], $country: ListingsCountry!, $kpiLevel: KpiLevel) {
  kpiMetrics(
    kpi: $kpi
    dateRange: $dateRange
    filters: $filters
    country: $country
    kpiLevel: $kpiLevel
  ) {
    kpi
    stats {
      sold {
        count
        avg {
          value
        }
      }
      active {
        avg {
          value
        }
        count
      }
      all {
        count
        avg {
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKpiMetricsQuery__
 *
 * To run a query within a React component, call `useKpiMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiMetricsQuery({
 *   variables: {
 *      kpi: // value for 'kpi'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      country: // value for 'country'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useKpiMetricsQuery(baseOptions: Apollo.QueryHookOptions<KpiMetricsQuery, KpiMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiMetricsQuery, KpiMetricsQueryVariables>(KpiMetricsDocument, options);
      }
export function useKpiMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiMetricsQuery, KpiMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiMetricsQuery, KpiMetricsQueryVariables>(KpiMetricsDocument, options);
        }
export type KpiMetricsQueryHookResult = ReturnType<typeof useKpiMetricsQuery>;
export type KpiMetricsLazyQueryHookResult = ReturnType<typeof useKpiMetricsLazyQuery>;
export type KpiMetricsQueryResult = Apollo.QueryResult<KpiMetricsQuery, KpiMetricsQueryVariables>;
export const KpiDaysOnMarketDocument = gql`
    query KpiDaysOnMarket($dateRange: DateRangeInput!, $filters: [ListingFilterInput], $country: ListingsCountry!, $kpiLevel: KpiLevel) {
  kpiDaysOnMarket(
    dateRange: $dateRange
    filters: $filters
    country: $country
    kpiLevel: $kpiLevel
  ) {
    kpi
    stats {
      active {
        percentageChange
        count
        avg {
          value
        }
      }
      sold {
        percentageChange
        count
        avg {
          value
        }
      }
      all {
        count
        percentageChange
        avg {
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKpiDaysOnMarketQuery__
 *
 * To run a query within a React component, call `useKpiDaysOnMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiDaysOnMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiDaysOnMarketQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      country: // value for 'country'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useKpiDaysOnMarketQuery(baseOptions: Apollo.QueryHookOptions<KpiDaysOnMarketQuery, KpiDaysOnMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiDaysOnMarketQuery, KpiDaysOnMarketQueryVariables>(KpiDaysOnMarketDocument, options);
      }
export function useKpiDaysOnMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiDaysOnMarketQuery, KpiDaysOnMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiDaysOnMarketQuery, KpiDaysOnMarketQueryVariables>(KpiDaysOnMarketDocument, options);
        }
export type KpiDaysOnMarketQueryHookResult = ReturnType<typeof useKpiDaysOnMarketQuery>;
export type KpiDaysOnMarketLazyQueryHookResult = ReturnType<typeof useKpiDaysOnMarketLazyQuery>;
export type KpiDaysOnMarketQueryResult = Apollo.QueryResult<KpiDaysOnMarketQuery, KpiDaysOnMarketQueryVariables>;
export const ListingVolumeMetricDocument = gql`
    query ListingVolumeMetric($dateRange: DateRangeInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  listingVolumeMetric(
    dateRange: $dateRange
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    kpi
    stats {
      sold {
        count
        avg {
          value
        }
        percentageChange
      }
      all {
        count
        percentageChange
        avg {
          value
        }
      }
      active {
        avg {
          value
        }
        count
        percentageChange
      }
    }
  }
}
    `;

/**
 * __useListingVolumeMetricQuery__
 *
 * To run a query within a React component, call `useListingVolumeMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingVolumeMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingVolumeMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingVolumeMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingVolumeMetricQuery, ListingVolumeMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingVolumeMetricQuery, ListingVolumeMetricQueryVariables>(ListingVolumeMetricDocument, options);
      }
export function useListingVolumeMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingVolumeMetricQuery, ListingVolumeMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingVolumeMetricQuery, ListingVolumeMetricQueryVariables>(ListingVolumeMetricDocument, options);
        }
export type ListingVolumeMetricQueryHookResult = ReturnType<typeof useListingVolumeMetricQuery>;
export type ListingVolumeMetricLazyQueryHookResult = ReturnType<typeof useListingVolumeMetricLazyQuery>;
export type ListingVolumeMetricQueryResult = Apollo.QueryResult<ListingVolumeMetricQuery, ListingVolumeMetricQueryVariables>;
export const ListingFieldHistogramDocument = gql`
    query ListingFieldHistogram($interval: DateIntervalInput!, $dateRange: DateRangeInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel, $field: FilterNumberField!) {
  listingFieldHistogram(
    interval: $interval
    dateRange: $dateRange
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
    field: $field
  ) {
    key
    count
  }
}
    `;

/**
 * __useListingFieldHistogramQuery__
 *
 * To run a query within a React component, call `useListingFieldHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingFieldHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingFieldHistogramQuery({
 *   variables: {
 *      interval: // value for 'interval'
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *      field: // value for 'field'
 *   },
 * });
 */
export function useListingFieldHistogramQuery(baseOptions: Apollo.QueryHookOptions<ListingFieldHistogramQuery, ListingFieldHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingFieldHistogramQuery, ListingFieldHistogramQueryVariables>(ListingFieldHistogramDocument, options);
      }
export function useListingFieldHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingFieldHistogramQuery, ListingFieldHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingFieldHistogramQuery, ListingFieldHistogramQueryVariables>(ListingFieldHistogramDocument, options);
        }
export type ListingFieldHistogramQueryHookResult = ReturnType<typeof useListingFieldHistogramQuery>;
export type ListingFieldHistogramLazyQueryHookResult = ReturnType<typeof useListingFieldHistogramLazyQuery>;
export type ListingFieldHistogramQueryResult = Apollo.QueryResult<ListingFieldHistogramQuery, ListingFieldHistogramQueryVariables>;
export const ListingFieldsDocument = gql`
    query ListingFields($makeFilters: [String]) {
  listingFields(makeFilters: $makeFilters) {
    filterField
    title
    type
    configuration {
      numberFilterConfiguration {
        from
        to
        unit
      }
      stringFilterConfiguration {
        condition
      }
      modelFilterConfiguration {
        make
      }
    }
  }
}
    `;

/**
 * __useListingFieldsQuery__
 *
 * To run a query within a React component, call `useListingFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingFieldsQuery({
 *   variables: {
 *      makeFilters: // value for 'makeFilters'
 *   },
 * });
 */
export function useListingFieldsQuery(baseOptions?: Apollo.QueryHookOptions<ListingFieldsQuery, ListingFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingFieldsQuery, ListingFieldsQueryVariables>(ListingFieldsDocument, options);
      }
export function useListingFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingFieldsQuery, ListingFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingFieldsQuery, ListingFieldsQueryVariables>(ListingFieldsDocument, options);
        }
export type ListingFieldsQueryHookResult = ReturnType<typeof useListingFieldsQuery>;
export type ListingFieldsLazyQueryHookResult = ReturnType<typeof useListingFieldsLazyQuery>;
export type ListingFieldsQueryResult = Apollo.QueryResult<ListingFieldsQuery, ListingFieldsQueryVariables>;
export const FieldCountsDocument = gql`
    query FieldCounts($after: String, $first: Int, $propertyName: CountField, $dateRange: DateRangeInput, $filters: [ListingFilterInput], $searchQuery: String, $country: ListingsCountry!) {
  fieldCounts(
    after: $after
    first: $first
    propertyName: $propertyName
    dateRange: $dateRange
    filters: $filters
    searchQuery: $searchQuery
    country: $country
  ) {
    nodes {
      count
      key
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useFieldCountsQuery__
 *
 * To run a query within a React component, call `useFieldCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldCountsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      propertyName: // value for 'propertyName'
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      searchQuery: // value for 'searchQuery'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useFieldCountsQuery(baseOptions: Apollo.QueryHookOptions<FieldCountsQuery, FieldCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldCountsQuery, FieldCountsQueryVariables>(FieldCountsDocument, options);
      }
export function useFieldCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldCountsQuery, FieldCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldCountsQuery, FieldCountsQueryVariables>(FieldCountsDocument, options);
        }
export type FieldCountsQueryHookResult = ReturnType<typeof useFieldCountsQuery>;
export type FieldCountsLazyQueryHookResult = ReturnType<typeof useFieldCountsLazyQuery>;
export type FieldCountsQueryResult = Apollo.QueryResult<FieldCountsQuery, FieldCountsQueryVariables>;
export const MakeModelCountsDocument = gql`
    query MakeModelCounts($makeName: String, $country: ListingsCountry!, $filters: [ListingFilterInput], $dateRange: DateRangeInput) {
  makeModelCounts(
    makeName: $makeName
    country: $country
    filters: $filters
    dateRange: $dateRange
  ) {
    count
    key
  }
}
    `;

/**
 * __useMakeModelCountsQuery__
 *
 * To run a query within a React component, call `useMakeModelCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMakeModelCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMakeModelCountsQuery({
 *   variables: {
 *      makeName: // value for 'makeName'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useMakeModelCountsQuery(baseOptions: Apollo.QueryHookOptions<MakeModelCountsQuery, MakeModelCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MakeModelCountsQuery, MakeModelCountsQueryVariables>(MakeModelCountsDocument, options);
      }
export function useMakeModelCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MakeModelCountsQuery, MakeModelCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MakeModelCountsQuery, MakeModelCountsQueryVariables>(MakeModelCountsDocument, options);
        }
export type MakeModelCountsQueryHookResult = ReturnType<typeof useMakeModelCountsQuery>;
export type MakeModelCountsLazyQueryHookResult = ReturnType<typeof useMakeModelCountsLazyQuery>;
export type MakeModelCountsQueryResult = Apollo.QueryResult<MakeModelCountsQuery, MakeModelCountsQueryVariables>;
export const ListingMarketDaysSupplyGeoMetricDocument = gql`
    query ListingMarketDaysSupplyGeoMetric($dateRange: DateRangeInput!, $zoomLevel: ZoomLevelInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  listingMarketDaysSupplyGeoMetric(
    dateRange: $dateRange
    zoomLevel: $zoomLevel
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    kpi
    geoResults {
      count
      postalCodes
    }
    geo {
      key
      value
    }
  }
}
    `;

/**
 * __useListingMarketDaysSupplyGeoMetricQuery__
 *
 * To run a query within a React component, call `useListingMarketDaysSupplyGeoMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingMarketDaysSupplyGeoMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingMarketDaysSupplyGeoMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      zoomLevel: // value for 'zoomLevel'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingMarketDaysSupplyGeoMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingMarketDaysSupplyGeoMetricQuery, ListingMarketDaysSupplyGeoMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingMarketDaysSupplyGeoMetricQuery, ListingMarketDaysSupplyGeoMetricQueryVariables>(ListingMarketDaysSupplyGeoMetricDocument, options);
      }
export function useListingMarketDaysSupplyGeoMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingMarketDaysSupplyGeoMetricQuery, ListingMarketDaysSupplyGeoMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingMarketDaysSupplyGeoMetricQuery, ListingMarketDaysSupplyGeoMetricQueryVariables>(ListingMarketDaysSupplyGeoMetricDocument, options);
        }
export type ListingMarketDaysSupplyGeoMetricQueryHookResult = ReturnType<typeof useListingMarketDaysSupplyGeoMetricQuery>;
export type ListingMarketDaysSupplyGeoMetricLazyQueryHookResult = ReturnType<typeof useListingMarketDaysSupplyGeoMetricLazyQuery>;
export type ListingMarketDaysSupplyGeoMetricQueryResult = Apollo.QueryResult<ListingMarketDaysSupplyGeoMetricQuery, ListingMarketDaysSupplyGeoMetricQueryVariables>;
export const ListingMarketDaysSupplyMetricDocument = gql`
    query ListingMarketDaysSupplyMetric($dateRange: DateRangeInput!, $filters: [ListingFilterInput], $country: ListingsCountry!, $kpiLevel: KpiLevel) {
  listingMarketDaysSupplyMetric(
    dateRange: $dateRange
    filters: $filters
    country: $country
    kpiLevel: $kpiLevel
  ) {
    kpi
    value
  }
}
    `;

/**
 * __useListingMarketDaysSupplyMetricQuery__
 *
 * To run a query within a React component, call `useListingMarketDaysSupplyMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingMarketDaysSupplyMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingMarketDaysSupplyMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      filters: // value for 'filters'
 *      country: // value for 'country'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingMarketDaysSupplyMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingMarketDaysSupplyMetricQuery, ListingMarketDaysSupplyMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingMarketDaysSupplyMetricQuery, ListingMarketDaysSupplyMetricQueryVariables>(ListingMarketDaysSupplyMetricDocument, options);
      }
export function useListingMarketDaysSupplyMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingMarketDaysSupplyMetricQuery, ListingMarketDaysSupplyMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingMarketDaysSupplyMetricQuery, ListingMarketDaysSupplyMetricQueryVariables>(ListingMarketDaysSupplyMetricDocument, options);
        }
export type ListingMarketDaysSupplyMetricQueryHookResult = ReturnType<typeof useListingMarketDaysSupplyMetricQuery>;
export type ListingMarketDaysSupplyMetricLazyQueryHookResult = ReturnType<typeof useListingMarketDaysSupplyMetricLazyQuery>;
export type ListingMarketDaysSupplyMetricQueryResult = Apollo.QueryResult<ListingMarketDaysSupplyMetricQuery, ListingMarketDaysSupplyMetricQueryVariables>;
export const ListingTypeCountsDocument = gql`
    query ListingTypeCounts($dateRange: DateRangeInput!, $country: ListingsCountry!, $filters: [ListingFilterInput]) {
  listingTypeCounts(dateRange: $dateRange, country: $country, filters: $filters) {
    count
    key
  }
}
    `;

/**
 * __useListingTypeCountsQuery__
 *
 * To run a query within a React component, call `useListingTypeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingTypeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingTypeCountsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListingTypeCountsQuery(baseOptions: Apollo.QueryHookOptions<ListingTypeCountsQuery, ListingTypeCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingTypeCountsQuery, ListingTypeCountsQueryVariables>(ListingTypeCountsDocument, options);
      }
export function useListingTypeCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingTypeCountsQuery, ListingTypeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingTypeCountsQuery, ListingTypeCountsQueryVariables>(ListingTypeCountsDocument, options);
        }
export type ListingTypeCountsQueryHookResult = ReturnType<typeof useListingTypeCountsQuery>;
export type ListingTypeCountsLazyQueryHookResult = ReturnType<typeof useListingTypeCountsLazyQuery>;
export type ListingTypeCountsQueryResult = Apollo.QueryResult<ListingTypeCountsQuery, ListingTypeCountsQueryVariables>;
export const ListingVolumeGeoMetricDocument = gql`
    query ListingVolumeGeoMetric($dateRange: DateRangeInput!, $zoomLevel: ZoomLevelInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  listingVolumeGeoMetric(
    dateRange: $dateRange
    zoomLevel: $zoomLevel
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    geo {
      avg {
        value
      }
      count
      key
    }
    geoResults {
      postalCodes
      count
    }
    kpi
  }
}
    `;

/**
 * __useListingVolumeGeoMetricQuery__
 *
 * To run a query within a React component, call `useListingVolumeGeoMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingVolumeGeoMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingVolumeGeoMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      zoomLevel: // value for 'zoomLevel'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingVolumeGeoMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingVolumeGeoMetricQuery, ListingVolumeGeoMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingVolumeGeoMetricQuery, ListingVolumeGeoMetricQueryVariables>(ListingVolumeGeoMetricDocument, options);
      }
export function useListingVolumeGeoMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingVolumeGeoMetricQuery, ListingVolumeGeoMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingVolumeGeoMetricQuery, ListingVolumeGeoMetricQueryVariables>(ListingVolumeGeoMetricDocument, options);
        }
export type ListingVolumeGeoMetricQueryHookResult = ReturnType<typeof useListingVolumeGeoMetricQuery>;
export type ListingVolumeGeoMetricLazyQueryHookResult = ReturnType<typeof useListingVolumeGeoMetricLazyQuery>;
export type ListingVolumeGeoMetricQueryResult = Apollo.QueryResult<ListingVolumeGeoMetricQuery, ListingVolumeGeoMetricQueryVariables>;
export const ListingVolumeHistogramDocument = gql`
    query ListingVolumeHistogram($interval: DateIntervalInput!, $dateRange: DateRangeInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  listingVolumeHistogram(
    interval: $interval
    dateRange: $dateRange
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    key
    count
  }
}
    `;

/**
 * __useListingVolumeHistogramQuery__
 *
 * To run a query within a React component, call `useListingVolumeHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingVolumeHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingVolumeHistogramQuery({
 *   variables: {
 *      interval: // value for 'interval'
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingVolumeHistogramQuery(baseOptions: Apollo.QueryHookOptions<ListingVolumeHistogramQuery, ListingVolumeHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingVolumeHistogramQuery, ListingVolumeHistogramQueryVariables>(ListingVolumeHistogramDocument, options);
      }
export function useListingVolumeHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingVolumeHistogramQuery, ListingVolumeHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingVolumeHistogramQuery, ListingVolumeHistogramQueryVariables>(ListingVolumeHistogramDocument, options);
        }
export type ListingVolumeHistogramQueryHookResult = ReturnType<typeof useListingVolumeHistogramQuery>;
export type ListingVolumeHistogramLazyQueryHookResult = ReturnType<typeof useListingVolumeHistogramLazyQuery>;
export type ListingVolumeHistogramQueryResult = Apollo.QueryResult<ListingVolumeHistogramQuery, ListingVolumeHistogramQueryVariables>;
export const ListingsDaysOnMarketGeoMetricDocument = gql`
    query ListingsDaysOnMarketGeoMetric($dateRange: DateRangeInput!, $zoomLevel: ZoomLevelInput!, $country: ListingsCountry!, $filters: [ListingFilterInput], $kpiLevel: KpiLevel) {
  listingDaysOnMarketGeoMetric(
    dateRange: $dateRange
    zoomLevel: $zoomLevel
    country: $country
    filters: $filters
    kpiLevel: $kpiLevel
  ) {
    geo {
      avg {
        value
      }
      count
      key
    }
    geoResults {
      count
      postalCodes
    }
    kpi
  }
}
    `;

/**
 * __useListingsDaysOnMarketGeoMetricQuery__
 *
 * To run a query within a React component, call `useListingsDaysOnMarketGeoMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsDaysOnMarketGeoMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsDaysOnMarketGeoMetricQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      zoomLevel: // value for 'zoomLevel'
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingsDaysOnMarketGeoMetricQuery(baseOptions: Apollo.QueryHookOptions<ListingsDaysOnMarketGeoMetricQuery, ListingsDaysOnMarketGeoMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingsDaysOnMarketGeoMetricQuery, ListingsDaysOnMarketGeoMetricQueryVariables>(ListingsDaysOnMarketGeoMetricDocument, options);
      }
export function useListingsDaysOnMarketGeoMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingsDaysOnMarketGeoMetricQuery, ListingsDaysOnMarketGeoMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingsDaysOnMarketGeoMetricQuery, ListingsDaysOnMarketGeoMetricQueryVariables>(ListingsDaysOnMarketGeoMetricDocument, options);
        }
export type ListingsDaysOnMarketGeoMetricQueryHookResult = ReturnType<typeof useListingsDaysOnMarketGeoMetricQuery>;
export type ListingsDaysOnMarketGeoMetricLazyQueryHookResult = ReturnType<typeof useListingsDaysOnMarketGeoMetricLazyQuery>;
export type ListingsDaysOnMarketGeoMetricQueryResult = Apollo.QueryResult<ListingsDaysOnMarketGeoMetricQuery, ListingsDaysOnMarketGeoMetricQueryVariables>;
export const ListingDaysOnMarketHistogramDocument = gql`
    query ListingDaysOnMarketHistogram($interval: Int, $max: Int, $min: Int, $filters: [ListingFilterInput], $minCountPerBucket: Int, $dateRange: DateRangeInput, $country: ListingsCountry!, $kpiLevel: KpiLevel) {
  listingDaysOnMarketHistogram(
    interval: $interval
    max: $max
    min: $min
    filters: $filters
    minCountPerBucket: $minCountPerBucket
    dateRange: $dateRange
    country: $country
    kpiLevel: $kpiLevel
  ) {
    average
    histogram {
      count
      key {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useListingDaysOnMarketHistogramQuery__
 *
 * To run a query within a React component, call `useListingDaysOnMarketHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingDaysOnMarketHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingDaysOnMarketHistogramQuery({
 *   variables: {
 *      interval: // value for 'interval'
 *      max: // value for 'max'
 *      min: // value for 'min'
 *      filters: // value for 'filters'
 *      minCountPerBucket: // value for 'minCountPerBucket'
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      kpiLevel: // value for 'kpiLevel'
 *   },
 * });
 */
export function useListingDaysOnMarketHistogramQuery(baseOptions: Apollo.QueryHookOptions<ListingDaysOnMarketHistogramQuery, ListingDaysOnMarketHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingDaysOnMarketHistogramQuery, ListingDaysOnMarketHistogramQueryVariables>(ListingDaysOnMarketHistogramDocument, options);
      }
export function useListingDaysOnMarketHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingDaysOnMarketHistogramQuery, ListingDaysOnMarketHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingDaysOnMarketHistogramQuery, ListingDaysOnMarketHistogramQueryVariables>(ListingDaysOnMarketHistogramDocument, options);
        }
export type ListingDaysOnMarketHistogramQueryHookResult = ReturnType<typeof useListingDaysOnMarketHistogramQuery>;
export type ListingDaysOnMarketHistogramLazyQueryHookResult = ReturnType<typeof useListingDaysOnMarketHistogramLazyQuery>;
export type ListingDaysOnMarketHistogramQueryResult = Apollo.QueryResult<ListingDaysOnMarketHistogramQuery, ListingDaysOnMarketHistogramQueryVariables>;
export const ListingsSnapshotDocument = gql`
    query ListingsSnapshot($country: ListingsCountry!, $before: String, $after: String, $first: Int, $last: Int, $filters: [ListingFilterInput], $sort: [String], $searchQuery: String, $dateRange: DateRangeInput) {
  listingsSnapshot(
    country: $country
    before: $before
    after: $after
    first: $first
    last: $last
    filters: $filters
    sort: $sort
    searchQuery: $searchQuery
    dateRange: $dateRange
  ) {
    totalCount
  }
}
    `;

/**
 * __useListingsSnapshotQuery__
 *
 * To run a query within a React component, call `useListingsSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsSnapshotQuery({
 *   variables: {
 *      country: // value for 'country'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      searchQuery: // value for 'searchQuery'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useListingsSnapshotQuery(baseOptions: Apollo.QueryHookOptions<ListingsSnapshotQuery, ListingsSnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingsSnapshotQuery, ListingsSnapshotQueryVariables>(ListingsSnapshotDocument, options);
      }
export function useListingsSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingsSnapshotQuery, ListingsSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingsSnapshotQuery, ListingsSnapshotQueryVariables>(ListingsSnapshotDocument, options);
        }
export type ListingsSnapshotQueryHookResult = ReturnType<typeof useListingsSnapshotQuery>;
export type ListingsSnapshotLazyQueryHookResult = ReturnType<typeof useListingsSnapshotLazyQuery>;
export type ListingsSnapshotQueryResult = Apollo.QueryResult<ListingsSnapshotQuery, ListingsSnapshotQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    addressLine1
    state
    id
    name
    country
    city
    phone
    owned
    zip
    userRoles {
      id
    }
    seatsTaken
    totalSeats
    listingsCountries
    imageUrl
    createdAt
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($updateOrganizationId: ID, $organization: OrganizationInput) {
  updateOrganization(id: $updateOrganizationId, organization: $organization) {
    id
  }
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      updateOrganizationId: // value for 'updateOrganizationId'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const AdminUpdateOrganizationDocument = gql`
    mutation AdminUpdateOrganization($input: AdminUpdateOrganizationInput!) {
  adminUpdateOrganization(input: $input) {
    id
  }
}
    `;
export type AdminUpdateOrganizationMutationFn = Apollo.MutationFunction<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;

/**
 * __useAdminUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationMutation, { data, loading, error }] = useAdminUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>(AdminUpdateOrganizationDocument, options);
      }
export type AdminUpdateOrganizationMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationResult = Apollo.MutationResult<AdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;
export const InvitesOrganizationDocument = gql`
    query InvitesOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    pendingInvites {
      id
      email
      owner
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useInvitesOrganizationQuery__
 *
 * To run a query within a React component, call `useInvitesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInvitesOrganizationQuery(baseOptions: Apollo.QueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
      }
export function useInvitesOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
        }
export type InvitesOrganizationQueryHookResult = ReturnType<typeof useInvitesOrganizationQuery>;
export type InvitesOrganizationLazyQueryHookResult = ReturnType<typeof useInvitesOrganizationLazyQuery>;
export type InvitesOrganizationQueryResult = Apollo.QueryResult<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>;
export const DeleteSentInviteDocument = gql`
    mutation DeleteSentInvite($deleteInviteId: ID!) {
  deleteInvite(id: $deleteInviteId) {
    status
  }
}
    `;
export type DeleteSentInviteMutationFn = Apollo.MutationFunction<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;

/**
 * __useDeleteSentInviteMutation__
 *
 * To run a mutation, you first call `useDeleteSentInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSentInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSentInviteMutation, { data, loading, error }] = useDeleteSentInviteMutation({
 *   variables: {
 *      deleteInviteId: // value for 'deleteInviteId'
 *   },
 * });
 */
export function useDeleteSentInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>(DeleteSentInviteDocument, options);
      }
export type DeleteSentInviteMutationHookResult = ReturnType<typeof useDeleteSentInviteMutation>;
export type DeleteSentInviteMutationResult = Apollo.MutationResult<DeleteSentInviteMutation>;
export type DeleteSentInviteMutationOptions = Apollo.BaseMutationOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;
export const ResendSentInviteDocument = gql`
    mutation ResendSentInvite($resendInviteId: ID!) {
  resendInvite(id: $resendInviteId) {
    status
  }
}
    `;
export type ResendSentInviteMutationFn = Apollo.MutationFunction<ResendSentInviteMutation, ResendSentInviteMutationVariables>;

/**
 * __useResendSentInviteMutation__
 *
 * To run a mutation, you first call `useResendSentInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSentInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSentInviteMutation, { data, loading, error }] = useResendSentInviteMutation({
 *   variables: {
 *      resendInviteId: // value for 'resendInviteId'
 *   },
 * });
 */
export function useResendSentInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendSentInviteMutation, ResendSentInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendSentInviteMutation, ResendSentInviteMutationVariables>(ResendSentInviteDocument, options);
      }
export type ResendSentInviteMutationHookResult = ReturnType<typeof useResendSentInviteMutation>;
export type ResendSentInviteMutationResult = Apollo.MutationResult<ResendSentInviteMutation>;
export type ResendSentInviteMutationOptions = Apollo.BaseMutationOptions<ResendSentInviteMutation, ResendSentInviteMutationVariables>;
export const MembersOrganizationDocument = gql`
    query MembersOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    userRoles {
      id
      owner
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useMembersOrganizationQuery__
 *
 * To run a query within a React component, call `useMembersOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembersOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
      }
export function useMembersOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
        }
export type MembersOrganizationQueryHookResult = ReturnType<typeof useMembersOrganizationQuery>;
export type MembersOrganizationLazyQueryHookResult = ReturnType<typeof useMembersOrganizationLazyQuery>;
export type MembersOrganizationQueryResult = Apollo.QueryResult<MembersOrganizationQuery, MembersOrganizationQueryVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: ID!, $userId: ID!) {
  removeMember(id: $organizationId, userId: $userId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const OrganizationNameImageDocument = gql`
    query OrganizationNameImage($organizationId: ID!) {
  organization(id: $organizationId) {
    name
    imageUrl
  }
}
    `;

/**
 * __useOrganizationNameImageQuery__
 *
 * To run a query within a React component, call `useOrganizationNameImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameImageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationNameImageQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
      }
export function useOrganizationNameImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
        }
export type OrganizationNameImageQueryHookResult = ReturnType<typeof useOrganizationNameImageQuery>;
export type OrganizationNameImageLazyQueryHookResult = ReturnType<typeof useOrganizationNameImageLazyQuery>;
export type OrganizationNameImageQueryResult = Apollo.QueryResult<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>;
export const SegmentsDocument = gql`
    query Segments($first: Int, $after: String, $before: String, $last: Int, $searchString: String, $filters: [SegmentFilter]) {
  segments(
    first: $first
    after: $after
    before: $before
    last: $last
    searchString: $searchString
    filters: $filters
  ) {
    totalCount
    nodes {
      id
      name
      processed
      creator {
        id
        firstName
        lastName
        imageUrl
      }
      createdAt
      updatedAt
      type
      country
      tag {
        id
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useSegmentsQuery__
 *
 * To run a query within a React component, call `useSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      searchString: // value for 'searchString'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
      }
export function useSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentsQuery, SegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentsQuery, SegmentsQueryVariables>(SegmentsDocument, options);
        }
export type SegmentsQueryHookResult = ReturnType<typeof useSegmentsQuery>;
export type SegmentsLazyQueryHookResult = ReturnType<typeof useSegmentsLazyQuery>;
export type SegmentsQueryResult = Apollo.QueryResult<SegmentsQuery, SegmentsQueryVariables>;
export const CreateSegmentFromVinsDocument = gql`
    mutation CreateSegmentFromVins($segment: SegmentFromVinsInput) {
  createSegmentFromVins(segment: $segment) {
    createdAt
    creator {
      id
      firstName
      lastName
      email
      phone
      imageUrl
      disableOrgs
    }
    id
    name
    documentUrl
    vinPosition
    updatedAt
  }
}
    `;
export type CreateSegmentFromVinsMutationFn = Apollo.MutationFunction<CreateSegmentFromVinsMutation, CreateSegmentFromVinsMutationVariables>;

/**
 * __useCreateSegmentFromVinsMutation__
 *
 * To run a mutation, you first call `useCreateSegmentFromVinsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentFromVinsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentFromVinsMutation, { data, loading, error }] = useCreateSegmentFromVinsMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useCreateSegmentFromVinsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentFromVinsMutation, CreateSegmentFromVinsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentFromVinsMutation, CreateSegmentFromVinsMutationVariables>(CreateSegmentFromVinsDocument, options);
      }
export type CreateSegmentFromVinsMutationHookResult = ReturnType<typeof useCreateSegmentFromVinsMutation>;
export type CreateSegmentFromVinsMutationResult = Apollo.MutationResult<CreateSegmentFromVinsMutation>;
export type CreateSegmentFromVinsMutationOptions = Apollo.BaseMutationOptions<CreateSegmentFromVinsMutation, CreateSegmentFromVinsMutationVariables>;
export const CreateSegmentFromGlobalDbDocument = gql`
    mutation CreateSegmentFromGlobalDb($segment: SegmentFromGlobalDbInput) {
  createSegmentFromGlobalDb(segment: $segment) {
    id
  }
}
    `;
export type CreateSegmentFromGlobalDbMutationFn = Apollo.MutationFunction<CreateSegmentFromGlobalDbMutation, CreateSegmentFromGlobalDbMutationVariables>;

/**
 * __useCreateSegmentFromGlobalDbMutation__
 *
 * To run a mutation, you first call `useCreateSegmentFromGlobalDbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentFromGlobalDbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentFromGlobalDbMutation, { data, loading, error }] = useCreateSegmentFromGlobalDbMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useCreateSegmentFromGlobalDbMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentFromGlobalDbMutation, CreateSegmentFromGlobalDbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentFromGlobalDbMutation, CreateSegmentFromGlobalDbMutationVariables>(CreateSegmentFromGlobalDbDocument, options);
      }
export type CreateSegmentFromGlobalDbMutationHookResult = ReturnType<typeof useCreateSegmentFromGlobalDbMutation>;
export type CreateSegmentFromGlobalDbMutationResult = Apollo.MutationResult<CreateSegmentFromGlobalDbMutation>;
export type CreateSegmentFromGlobalDbMutationOptions = Apollo.BaseMutationOptions<CreateSegmentFromGlobalDbMutation, CreateSegmentFromGlobalDbMutationVariables>;
export const SegmentDocument = gql`
    query Segment($segmentId: ID!) {
  segment(id: $segmentId) {
    name
    id
    creator {
      id
      firstName
      lastName
    }
    updatedAt
    type
    country
    filters {
      numberFilter {
        field
        operator {
          eq
          in
          lt
          lte
          gt
          gte
          between {
            to
            from
          }
        }
      }
      stringFilter {
        field
        operator {
          eq
          in
        }
      }
      booleanFilter {
        field
        operator {
          eq
        }
      }
      dateFilter {
        field
        operator {
          lt
          lte
          gt
          gte
          between {
            to
            from
          }
        }
      }
      geoFilter {
        excludedZipCodes
        operator {
          distance {
            location {
              latitude
              longitude
            }
            distance
            unit
          }
          polygon {
            latitude
            longitude
          }
          region
        }
        place {
          address
          postalCode
        }
      }
      makeModelFilter {
        combinations {
          make
          model
        }
      }
    }
    dateRange {
      from
      to
    }
  }
}
    `;

/**
 * __useSegmentQuery__
 *
 * To run a query within a React component, call `useSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useSegmentQuery(baseOptions: Apollo.QueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
      }
export function useSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
        }
export type SegmentQueryHookResult = ReturnType<typeof useSegmentQuery>;
export type SegmentLazyQueryHookResult = ReturnType<typeof useSegmentLazyQuery>;
export type SegmentQueryResult = Apollo.QueryResult<SegmentQuery, SegmentQueryVariables>;
export const UpdateSegmentDocument = gql`
    mutation updateSegment($input: SegmentUpdateInput!) {
  updateSegment(input: $input) {
    id
  }
}
    `;
export type UpdateSegmentMutationFn = Apollo.MutationFunction<UpdateSegmentMutation, UpdateSegmentMutationVariables>;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentMutation, { data, loading, error }] = useUpdateSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentMutation, UpdateSegmentMutationVariables>(UpdateSegmentDocument, options);
      }
export type UpdateSegmentMutationHookResult = ReturnType<typeof useUpdateSegmentMutation>;
export type UpdateSegmentMutationResult = Apollo.MutationResult<UpdateSegmentMutation>;
export type UpdateSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>;
export const DeleteSegmentDocument = gql`
    mutation DeleteSegment($deleteSegmentId: ID!) {
  deleteSegment(id: $deleteSegmentId) {
    id
  }
}
    `;
export type DeleteSegmentMutationFn = Apollo.MutationFunction<DeleteSegmentMutation, DeleteSegmentMutationVariables>;

/**
 * __useDeleteSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSegmentMutation, { data, loading, error }] = useDeleteSegmentMutation({
 *   variables: {
 *      deleteSegmentId: // value for 'deleteSegmentId'
 *   },
 * });
 */
export function useDeleteSegmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSegmentMutation, DeleteSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSegmentMutation, DeleteSegmentMutationVariables>(DeleteSegmentDocument, options);
      }
export type DeleteSegmentMutationHookResult = ReturnType<typeof useDeleteSegmentMutation>;
export type DeleteSegmentMutationResult = Apollo.MutationResult<DeleteSegmentMutation>;
export type DeleteSegmentMutationOptions = Apollo.BaseMutationOptions<DeleteSegmentMutation, DeleteSegmentMutationVariables>;
export const SegmentProcessedDocument = gql`
    subscription SegmentProcessed($segmentIds: [ID]) {
  segmentProcessed(segmentIds: $segmentIds) {
    name
    id
    creator {
      id
      firstName
      lastName
      imageUrl
    }
    updatedAt
    type
    country
    processed
    filters {
      numberFilter {
        field
        operator {
          eq
          in
          lt
          lte
          gt
          gte
          between {
            to
            from
          }
        }
      }
      stringFilter {
        field
        operator {
          eq
          in
        }
      }
      booleanFilter {
        field
        operator {
          eq
        }
      }
      dateFilter {
        field
        operator {
          lt
          lte
          gt
          gte
          between {
            to
            from
          }
        }
      }
      geoFilter {
        excludedZipCodes
        operator {
          distance {
            location {
              latitude
              longitude
            }
            distance
            unit
          }
          polygon {
            latitude
            longitude
          }
          region
        }
        place {
          address
          postalCode
        }
      }
      makeModelFilter {
        combinations {
          make
          model
        }
      }
    }
    dateRange {
      from
      to
    }
  }
}
    `;

/**
 * __useSegmentProcessedSubscription__
 *
 * To run a query within a React component, call `useSegmentProcessedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSegmentProcessedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentProcessedSubscription({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *   },
 * });
 */
export function useSegmentProcessedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SegmentProcessedSubscription, SegmentProcessedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SegmentProcessedSubscription, SegmentProcessedSubscriptionVariables>(SegmentProcessedDocument, options);
      }
export type SegmentProcessedSubscriptionHookResult = ReturnType<typeof useSegmentProcessedSubscription>;
export type SegmentProcessedSubscriptionResult = Apollo.SubscriptionResult<SegmentProcessedSubscription>;
export const TagsDocument = gql`
    query Tags($first: Int, $after: String, $searchString: String) {
  tags(first: $first, after: $after, searchString: $searchString) {
    nodes {
      name
      id
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($input: CreateTagInput) {
  createTag(input: $input) {
    id
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const TagSegmentDocument = gql`
    mutation TagSegment($tagId: ID!, $tagSegmentId: ID!) {
  tagSegment(tagId: $tagId, id: $tagSegmentId) {
    id
  }
}
    `;
export type TagSegmentMutationFn = Apollo.MutationFunction<TagSegmentMutation, TagSegmentMutationVariables>;

/**
 * __useTagSegmentMutation__
 *
 * To run a mutation, you first call `useTagSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSegmentMutation, { data, loading, error }] = useTagSegmentMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      tagSegmentId: // value for 'tagSegmentId'
 *   },
 * });
 */
export function useTagSegmentMutation(baseOptions?: Apollo.MutationHookOptions<TagSegmentMutation, TagSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagSegmentMutation, TagSegmentMutationVariables>(TagSegmentDocument, options);
      }
export type TagSegmentMutationHookResult = ReturnType<typeof useTagSegmentMutation>;
export type TagSegmentMutationResult = Apollo.MutationResult<TagSegmentMutation>;
export type TagSegmentMutationOptions = Apollo.BaseMutationOptions<TagSegmentMutation, TagSegmentMutationVariables>;
export const UntagSegmentDocument = gql`
    mutation UntagSegment($untagSegmentId: ID!) {
  untagSegment(id: $untagSegmentId) {
    id
  }
}
    `;
export type UntagSegmentMutationFn = Apollo.MutationFunction<UntagSegmentMutation, UntagSegmentMutationVariables>;

/**
 * __useUntagSegmentMutation__
 *
 * To run a mutation, you first call `useUntagSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntagSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untagSegmentMutation, { data, loading, error }] = useUntagSegmentMutation({
 *   variables: {
 *      untagSegmentId: // value for 'untagSegmentId'
 *   },
 * });
 */
export function useUntagSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UntagSegmentMutation, UntagSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UntagSegmentMutation, UntagSegmentMutationVariables>(UntagSegmentDocument, options);
      }
export type UntagSegmentMutationHookResult = ReturnType<typeof useUntagSegmentMutation>;
export type UntagSegmentMutationResult = Apollo.MutationResult<UntagSegmentMutation>;
export type UntagSegmentMutationOptions = Apollo.BaseMutationOptions<UntagSegmentMutation, UntagSegmentMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput) {
  updateTag(input: $input) {
    id
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($deleteTagId: ID!) {
  deleteTag(id: $deleteTagId) {
    id
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      deleteTagId: // value for 'deleteTagId'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    admin
    disableOrgs
    organizations {
      id
      name
      legalName
      addressLine1
      addressLine2
      state
      zip
      country
      city
      imageUrl
      phone
      createdAt
      updatedAt
      userRoles {
        id
        owner
        createdAt
        updatedAt
        user {
          id
          firstName
          lastName
          imageUrl
        }
      }
      owned
      pendingInvites {
        id
        email
        owner
        organizationId
        createdByUserId
        status
        createdAt
        updatedAt
        acceptedAt
        declinedAt
        deletedAt
      }
      listingsCountries
    }
    invites {
      id
      email
      owner
      organizationId
      createdByUserId
      status
      createdAt
      updatedAt
      acceptedAt
      declinedAt
      deletedAt
      inviter {
        id
        firstName
        lastName
        email
        phone
        imageUrl
        disableOrgs
      }
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
        disableOrgs
      }
      organization {
        id
        name
        legalName
        addressLine1
        addressLine2
        state
        zip
        country
        city
        imageUrl
        phone
        createdAt
        updatedAt
        owned
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($user: UpdateUserInput) {
  updateMe(user: $user) {
    firstName
    lastName
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const VehiclesSnapshotDocument = gql`
    query VehiclesSnapshot($first: Int, $after: String, $filters: [ListingFilterInput], $sort: [String], $searchQuery: String, $dateRange: DateRangeInput!, $country: ListingsCountry!, $getListings: Boolean!) {
  vehiclesSnapshot(
    first: $first
    after: $after
    filters: $filters
    sort: $sort
    searchQuery: $searchQuery
    dateRange: $dateRange
    country: $country
  ) {
    nodes {
      listingType
      vin
      stockType
      fuelTypeFromVin
      dealerType
      listingFirstDate
      listingDropoffDate
      hasNavigation
      hasLeather
      certified
      make
      model
      modelYear
      series
      style
      transmissionFromVin
      listingsCount
      uvc
      mileage
      price
      msrp
      dealerListingMSRP
      listings @include(if: $getListings) {
        listingFirstDate
        listingLastDate
        listingDropoffDate
        listingUrl
        listingType
        dealerName
        dealerStreet
        dealerCity
        dealerState
        dealerZipcode
        dealerUrl
        dealerPhone
        vin
        stockType
        price
        intentMsgPrice
        msrp
        dealerListingMSRP
        mileage
        intentMsgMileage
        fuelTypeFromVin
        priceHistory {
          price
          updatedAt
        }
        numberPriceChanges
        dealerType
        hasNavigation
        hasLeather
        certified
        locationScore
        make
        model
        modelYear
        series
        style
        transmissionFromVin
        uvc
        listedDays
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useVehiclesSnapshotQuery__
 *
 * To run a query within a React component, call `useVehiclesSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesSnapshotQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      searchQuery: // value for 'searchQuery'
 *      dateRange: // value for 'dateRange'
 *      country: // value for 'country'
 *      getListings: // value for 'getListings'
 *   },
 * });
 */
export function useVehiclesSnapshotQuery(baseOptions: Apollo.QueryHookOptions<VehiclesSnapshotQuery, VehiclesSnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehiclesSnapshotQuery, VehiclesSnapshotQueryVariables>(VehiclesSnapshotDocument, options);
      }
export function useVehiclesSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehiclesSnapshotQuery, VehiclesSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehiclesSnapshotQuery, VehiclesSnapshotQueryVariables>(VehiclesSnapshotDocument, options);
        }
export type VehiclesSnapshotQueryHookResult = ReturnType<typeof useVehiclesSnapshotQuery>;
export type VehiclesSnapshotLazyQueryHookResult = ReturnType<typeof useVehiclesSnapshotLazyQuery>;
export type VehiclesSnapshotQueryResult = Apollo.QueryResult<VehiclesSnapshotQuery, VehiclesSnapshotQueryVariables>;